import Link from "next/link";
import { siteSettings } from "@workspace/utils";
import { ctas } from ".";

export const basicInfo = {
    brandsTitle: "Where Our Mentors Come From & Our Clients Get In",
    ctas: ctas,
    brands: [
        {
            src: "/Homepage_headerimg_Harvard_University logo.png",
            alt: "Harvard Business School"
        },
        {
            src: "/Homepage_headerimg_ISB logo.png",
            alt: "Indian School of Business"
        },
        {
            src: "/Homepage_headerimg_Insead logo.webp",
            alt: "INSEAD"
        },
        {
            src: "/Homepage_headerimg_Stanford logo.png",
            alt: "Stanford Graduate School of Business"
        },
        {
            src: "/Homepage_headerimg_HEC_Paris logo.png",
            alt: "HEC Paris"
        },
        {
            src: "/Homepage_headerimg_LBS logo.jpg",
            alt: "London Business School"
        },
        {
            src: "/Homepage_Chicago Booth Logo.jpeg",
            alt: "The University of Chicago Booth School of Business"
        },
        {
            src: "/MBA page Oxford logo.webp",
            alt: "Oxford Saïd Business School"
        },
        {
            src: "/IE _logo_og.png",
            alt: "IE Business School"
        }
    ]
}

export const courses = {
    'master-of-business-administration': {
        pricingKey: "MBA",
        pricingTitle: "Tailored made pricing plans for your MBA journey",
        productHomeHeroConfig: {
            title: "MBA Admissions guidance — No Fluff, All Strategy",
            subtitle: `${siteSettings.siteName} turns your story into an admit-ready MBA application`,
            description: "An MBA is a 10–24 month graduate degree for professionals with about 3–8 years of experience who want to accelerate or pivot into consulting, finance, product, or venture capital. GradBrew's alumni mentors help you get into M7, Top 20, and elite global MBA programs — with <strong>sharp essays, CV, and interview prep, and zero ghostwriting</strong>.",

            heroImage: {
                src: "/MBA_header top1.png",
                alt: "MBA Admission Consulting"
            },
            ...basicInfo
        },
        industrySolutionsConfig: [
            {
                //iconDark: "https://dummyimage.com/460x460/fef/aba",
                //icon: "https://dummyimage.com/460x460/fef/aba",
                title: "MBA at a Glance",
                description: (
                    <>
                        <li><strong>Target audience:</strong> Professionals with roughly 3–8 years of experience who want to accelerate or pivot their careers.</li><br />
                        <li><strong>Core focus:</strong> Leadership, global strategy, entrepreneurship, and high-impact networking, all built for strong ROI.</li><br />
                        <li><strong>Career outcomes:</strong> Fast tracks into consulting, finance, product management, venture capital, and future C-suite roles.</li><br />
                        <li><strong>Degree format:</strong> An intense 10- to 24-month immersion that blends case studies, live projects, and international treks to build a truly global mindset.</li><br />
                        <li><strong>Network effect:</strong> Join an alumni community that opens doors to top firms, seed funding, and senior mentors long after graduation.</li>

                    </>
                ),
            },
            {
                //iconDark: "https://dummyimage.com/460x460/fef/aba",
                //icon: "https://dummyimage.com/460x460/fef/aba",
                title: "Who Should Apply?",
                description: (
                    <ol style={{ paddingLeft: "0" }}>
                        <li><strong>3–10 yrs of impact—</strong> rapid career growth, team leadership, or entrepreneurial wins</li><br />
                        <li><strong>Any bachelor’s (or higher)—</strong> engineering to arts; a solid GPA counts more than major</li><br />
                        <li><strong>Competitive GMAT / GRE— </strong> (or test-optional where allowed) to prove quant readiness</li><br />
                        <li><strong>English-ready— </strong> TOEFL/IELTS only if prior studies weren’t in English.</li><br />
                        <li><strong>Clear leadership vision— </strong> know the “why MBA” and the impact you’ll drive post-grad.</li><br />
                        <li><strong>Global start dates— </strong> most programs kick off in September; selected schools open January cohorts.</li>
                    </ol>
                ),
            },
            {
                title: "MBA vs MiM: Which Should You Apply To?",
                description: (
                    <ul style={{ paddingLeft: "1.25rem" }}>
                        <li><strong>Experience:</strong> an MBA suits 3–8+ years of work; a MiM suits 0–3 years (pre-experience).</li>
                        <li><strong>Best for:</strong> an MBA fits mid-career professionals; a MiM fits final-year students and recent graduates.</li>
                        <li><strong>Length:</strong> both typically run 10–24 months.</li>
                        <li><strong>Goal:</strong> an MBA accelerates or pivots an established career; a MiM launches one.</li>
                        <li><strong>Admissions test:</strong> an MBA usually expects a competitive GMAT/GRE; a MiM is more often test-optional.</li>
                    </ul>
                ),
            },
        ],
        industryBenefitsConfig: {
            headline: "Why choose GradBrew for your MBA?",
            benefitList: [
                {
                    icon: "/Smart_Profile_Eval.png",
                    title: "Smart Profile Evaluation",
                    description: "Clear, honest, and personalised scorecard of your strengths, gaps, and admit odds— so every next step is targeted.",
                },
                {
                    icon: "/Data_driven_shortlist.png",
                    title: "Data-Driven Shortlist",
                    description: "Dream, target, and safety schools selected by alumni + analytics— no random lists, just ROI-fit options worldwide.",
                },
                {
                    icon: "/Essay_SOP_authentic.png",
                    title: "Authentic Essays and SOPs",
                    description: "You draft (or AI-draft), we sharpen. Two consultant passes ensure voice, impact, and ethical polish.",
                },
                {
                    icon: "/CV_LOR_Support.png",
                    title: "CV and LOR Support",
                    description: "MBA-standard résumé makeover and step-by-step guidance for recommenders to hit leadership keywords.",
                },
                {
                    icon: "/School_style_mock.png",
                    title: "School-Style Mock Interviews",
                    description: "Personal, video, and group case drills that mirror each program’s format—real-time feedback, real confidence.",
                },
                {
                    icon: "/Dual_Consultant.png",
                    title: "Dual Consultant Review",
                    description: "Lead alum shapes strategy; second top-school expert gives the pre-submit once-over. Two sets of eyes, zero weak links.",
                },
                {
                    icon: "/Scholarship_review.png",
                    title: "Scholarship + Extra Doc Review",
                    description: "We fine-tune optional essays, scholarship statements, and any addendum— so every supplemental page works harder for you.",
                },
                {
                    icon: "/Personalised_planner.png",
                    title: "Personalised Planner + Dashboard",
                    description: "Deadlines, drafts, feedback— all tracked in one sleek hub. See exactly what’s due and what’s approved, in real time.",
                },
                {
                    icon: "/Post_admit_guide.png",
                    title: "Post-Admit Guidance",
                    description: "Tips on visas, housing, banking, arrival hacks and settling in— based on your admitted country.",
                },
            ],
        },
        industryFeaturesTitle: "Your GradBrew MBA Journey — Step by Step",
        industryFeaturesConfig: [
            {
                title: "Kick-off: Complete Your Info Sheet",
                description: (
                    <>
                        A fast,high-signal form that captures your academics, experience, and career goals— fueling every tailored move we make next.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Kickoff infosheet.png",
                    alt: "Complete Your Info Sheet",
                },
            },
            {
                title: "Brainstorming: Strategy Call",
                description: (
                    <>
                        A focused 1-to-1 session with your Lead Consultant to lock school targets, carve your story arc, and pinpoint what makes you stand out.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_brainstorming strategy.png",
                    alt: "Brainstorming Call",
                },
            },
            {
                title: "First Drafts: Using Guidance and Smart Tools",
                description: (
                    <>
                        Spin up your first CV, essays, and recommender briefs with smart tools and templates, quick-hit video guides, and tips from your Lead Consultant— all while keeping the voice unmistakably yours.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_first draft.png",
                    alt: "First Drafts Using Smart Tools",
                },
            },
            {
                title: "Consultant Calls and Unlimited Draft Revisions",
                description: (
                    <>
                        Your Lead Consultant deep-dives into your drafts and suggests structured edits. Team works with you to sharpen structure, language, and impact— until every line earns its spot and still sounds unmistakably you.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Con revision.png",
                    alt: "Consultant Discussion & Revisions",
                },
            },
            {
                title: "Final Review by Second Expert Consultant",
                description: (
                    <>
                        Once near-final, a second expert (also a top-school alum) reviews your entire essays/SOP with fresh eyes for final polishing and strategy alignment. Back-to-front audit— spotting gaps, sharpening strategy, and adding the final polish before you hit “Submit Application”.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Dual expert review.png",
                    alt: "Dual Expert Review",
                },
            },
            {
                title: "Submit Strong and Nail the Interview",
                description: (
                    <>
                        Application locked. Now we drill for every behavioral and technical question with school-style mock sessions— so you walk in confident and walk out admitted. <br /> Need post-admit help? We’re still on call for visas, housing, and day-one prep.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_nail interview.png",
                    alt: "Submit Strong and Nail the Interview",
                },
            },
        ],
        faqs: [
            {
                category: "Eligibility and Fit",
                items: [
                    {
                        question: "Who should apply for an MBA?",
                        answer: (
                            <>
                                Professionals with 2–8 years of full-time work experience looking to pivot careers, accelerate growth, or build leadership skills across industries.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply without a business background?",
                        answer: (
                            <>
                                Yes. MBA programs value diversity in academic and professional backgrounds — engineers, lawyers, doctors, creatives, and others are equally welcome.
                            </>
                        ),
                    },
                    {
                        question: "Is there an age limit to apply?",
                        answer: (
                            <>
                                No formal limit. Most full-time MBA applicants are 25–32 years old, but older candidates with strong goals and leadership often succeed.
                            </>
                        ),
                    },
                    {
                        question: "How much work experience is ideal?",
                        answer: (
                            <>
                                4+ years is the sweet spot, but it depends on quality over quantity — demonstrated impact, leadership, and progression matter most.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Application Requirements",
                items: [
                    {
                        question: "Do I need GMAT or GRE to apply?",
                        answer: (
                            <>
                                Most schools require a test, but many offer test waivers or have test-optional routes. We help evaluate if you seek test waiver options.
                            </>
                        ),
                    },
                    {
                        question: "What are the typical documents required?",
                        answer: (
                            <>
                                Your application usually includes:
                                <ul>
                                    <li>CV/resume</li>
                                    <li>Test scores (GMAT/GRE, TOEFL/IELTS if needed)</li>
                                    <li>Essays/SOPs</li>
                                    <li>Letters of recommendation (LORs)</li>
                                    <li>Academic transcripts</li>
                                    <li>Application form + fee</li>
                                    <li>Additional school-specific requirements</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "How important are essays/SOP and letter of recommendations?",
                        answer: (
                            <>
                                Very important. Essays/SOP shape your personal brand. LORs validate your professional value. Together, they tell your story beyond numbers.
                            </>
                        ),
                    },
                    {
                        question: "What do top schools look for in a resume?",
                        answer: (
                            <>
                                Impact, leadership, and progression matter more than job titles. We help reframe your experience into a B-school-optimized format.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Planning and Timeline",
                items: [
                    {
                        question: "When should I start my MBA application prep?",
                        answer: (
                            <>
                                Ideally 2-4 months before target round deadlines. But we’ve supported clients with fast-tracked 3–4 week timelines with focused workflows.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply in Round 2 or 3?",
                        answer: (
                            <>
                                Yes. Round 2 (Dec–Jan) is still very competitive. Round 3 is riskier but can work for strong profiles or regional schools. Some schools have specific round deadlines for international applicants.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply to multiple MBA programs at once?",
                        answer: (
                            <>
                                Absolutely. In fact, it’s encouraged. Each application should be customized — and we’ll help you manage everything strategically.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Costs and Scholarships",
                items: [
                    {
                        question: "What’s the average cost of an MBA?",
                        answer: (
                            <>
                                Tuition ranges from $80,000–$150,000 (USD), plus living expenses. European and Asian programs are usually more cost-effective.
                            </>
                        ),
                    },
                    {
                        question: "Are scholarships available for MBA students?",
                        answer: (
                            <>
                                Yes — most top schools offer merit- and need-based scholarships. Applying early and telling a compelling story helps improve chances. There are also several scholarships outside school offered by some organisations.
                            </>
                        ),
                    },
                    {
                        question: "Can GradBrew help with scholarship essays?",
                        answer: (
                            <>
                                Yes. Scholarship support is included in all packages — we help connect your goals and background to the school’s impact themes.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "GradBrew Process & Support",
                items: [
                    {
                        question: "How is GradBrew’s MBA support different?",
                        answer: (
                            <>
                                <ul>
                                    <li>Ethical consulting — no ghostwriting</li>
                                    <li>Two expert consultants (a Lead Consultant and an Expert) reviews application before you submit</li>
                                    <li>AI-assisted planning tools and feedback</li>
                                    <li>Clear dashboards and flexible timelines</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "Can I get help for just one school or one document?",
                        answer: (
                            <>
                                Yes — sometimes we offer standalone services for essays, CVs, LOR strategy, and interviews. You only pay for what you need. But, for serious applicants, we recommend opting for school packages.
                            </>
                        ),
                    },
                    {
                        question: "What does the process look like once I enroll?",
                        answer: (
                            <>
                                It starts with an infosheet and brainstorming strategy call. Then you draft using tools/templates, get feedback from your lead consultant, and finalize with input from a second expert. Then, you submit application and prepare for interviews with us.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Post-Admit and Career Outcomes",
                items: [
                    {
                        question: "What kind of jobs do MBA grads typically get?",
                        answer: (
                            <>
                                Consulting, product management, finance, venture capital, sustainability, and entrepreneurship are the most common post-MBA roles.
                            </>
                        ),
                    },
                    {
                        question: "What support does GradBrew offer after admission?",
                        answer: (
                            <>
                                We only guide on visas, housing, pre-MBA coursework, and even help you set career goals before joining school.
                            </>
                        ),
                    },
                    {
                        question: "Is an MBA worth it today?",
                        answer: (
                            <>
                                If you want long-term leadership growth, international mobility, and access to global networks — a well-chosen MBA still delivers strong ROI.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Test-Related FAQs",
                items: [
                    {
                        question: "Is GMAT or GRE mandatory for MBA applications?",
                        answer: (
                            <>
                                Most top MBA programs accept either GMAT or GRE. However, many schools now offer test waivers or are test-optional — especially if you have strong academic or professional credentials.
                            </>
                        ),
                    },
                    {
                        question: "Should I take the GMAT or GRE?",
                        answer: (
                            <>
                                Both are accepted widely. GMAT is often seen as more MBA-aligned, while GRE offers flexibility if you’re also considering other graduate programs. We help you decide based on your profile and school list.
                            </>
                        ),
                    },
                    {
                        question: "What’s a competitive GMAT or GRE score for top MBAs?",
                        answer: (
                            <>
                                <ul>
                                    <li>Top 10 schools: GMAT Focus 665+ or GRE 334+</li>
                                    <li>Top 30 schools: GMAT Focus 625+ or GRE 324+</li>
                                </ul>
                                That said, a lower score can still be offset with strong essays, experience, and goals. We help build holistic applications.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply before taking the GMAT/GRE?",
                        answer: (
                            <>
                                Yes — many schools let you submit your application and update your score later. For test waivers, we also help build a strong waiver request.
                            </>
                        ),
                    },
                    {
                        question: "What is the Executive Assessment (EA) and should I take it?",
                        answer: (
                            <>
                                The EA is a shorter, more experience-focused alternative to the GMAT, accepted by some programs (mostly Executive MBA or Flex MBAs). It’s a great option if you have 9+ years of experience and want a lighter test.
                            </>
                        ),
                    },
                ],
            },
        ],
        ctaConfig: {
            title: "Ready to Launch Your MBA Journey with GradBrew?",
            description: ` 
                <ul>
                    <li><strong>Built-for-you game plan</strong> – dual-consultant guidance, AI smart-tools, and a dashboard that tracks every milestone from first draft to admit.</li><br/>
                    <li><strong>Ethical edge</strong> – no ghostwriting, no cookie-cutter essays; just your authentic story sharpened for M7 & Top-20 ad-coms.</li><br/>
                    <li><strong>Interview-proof confidence</strong> – school-specific mock sessions, leadership pitch coaching, and scholarship positioning.</li><br/>
                    <li><strong>Post-admit peace of mind</strong> – visa, housing, and day-one prep, plus early-access to our Career Studio platform (additional paid service).</li><br/><br/>
                </ul>`,
            buttons: [
                { href: "#pricing-plan", text: "Pricing", className: "button is-large w-button" },
                { href: "#why-us", text: "Why US?", className: "button-outline is-large w-button" }
            ]
        }
    },
    'master-in-finance': {
        pricingKey: "MFIN",
        pricingTitle: "Tailored made pricing plans for your MFin journey",
        productHomeHeroConfig: {
            title: "Crack Top Master in Finance or Master of Financial Engineering Programs",
            subtitle: `Get coaching for finance-heavy applications— specialised essays to intensive interviews`,
            description: "A Master in Finance (MFin) or Master of Financial Engineering (MFE) is a 9–18 month, quant-focused master's for early-career graduates and analysts (0–4 years) targeting front-office finance. GradBrew's alumni mentors help you get into programs like MIT Sloan, LBS, and LSE — with <strong>ethics-first edits, data-driven strategy, and targeted interview prep</strong>.",

            heroImage: {
                src: "/GradBrew_Mfin_Header_og.png",
                alt: "GradBrew Master in Finance"
            },
            brandsTitle: "Where Our Mentors Come From & Our Clients Get In",
            ctas: ctas,
            brands: [
                {
                    src: "/MBA page Oxford logo.webp",
                    alt: "Oxford Saïd Business School"
                },
                {
                    src: "/Homepage_headerimg_HEC_Paris logo.png",
                    alt: "HEC Paris"
                },
                {
                    src: "/MIT_logo_og.png",
                    alt: "MIT Sloan School of Management"
                },
                {
                    src: "/Homepage_headerimg_LBS logo.jpg",
                    alt: "London Business School"
                },
                {
                    src: "/Homepage_headerimg ESCP logo.png",
                    alt: "ESCP Business School"
                },
                {
                    src: "/IE _logo_og.png",
                    alt: "IE Business School"
                },
                {
                    src: "/NUS_logo_og.png",
                    alt: "National University of Singapore"
                },
                {
                    src: "/Homepage_headerimg_LSE logo.png",
                    alt: "London School of Economics and Political Science"
                },
                {
                    src: "/Homepage_UTexas Austin Logo.png",
                    alt: "The University of Texas at Austin"
                }
            ]
        },
        industrySolutionsConfig: [
            {
                title: "Master in Finance (MFin) / Master of Financial Engineering (MFE) at a Glance",
                description: (
                    <>
                        <li><strong>Target audience:</strong> Early-career grads and analysts (0–4 years of experience) with sharp quantitative skills aiming to deepen finance expertise.</li><br />
                        <li><strong>Core focus:</strong> Valuation, asset management, quantitative modelling, and Python/R (mandatory for MFE) for markets, built to meet CFA and desk-ready standards.</li><br />
                        <li><strong>Career outcomes:</strong> Front-office roles in investment banking, buy-side asset management, quant research, risk, and corporate–finance leadership tracks.</li><br />
                        <li><strong>Degree format:</strong> A rigorous 9- to 18-month programme mixing casework, live trading labs, and practicum projects with top financial institutions.</li><br />
                        <li><strong>Network effect:</strong> Tap an alumni base embedded at bulge-bracket banks, hedge funds, and PE/VC firms—plus direct recruiting pipelines and CFA partnerships.</li>
                    </>
                ),
            },
            {
                title: "Who Should Apply?",
                description: (
                    <ol style={{ paddingLeft: "0" }}>
                        <li><strong>0–4 yrs experience—</strong> internships or early roles in finance, analytics, or engineering that show quantitative aptitude.</li><br />
                        <li><strong>Quant-friendly degree—</strong> finance, economics, STEM, or any major with strong math grades and a solid GPA.</li><br />
                        <li><strong>GMAT/GRE or CFA Level 1 (or above) </strong>— competitive scores (or CFA progress) to prove technical finance readiness.</li><br />
                        <li><strong>Programming edge (mandatory for MFE)—</strong> Advanced Python/R/Programming skills boosts profile for Financial Engineering programs.</li><br />
                        <li><strong>English-ready—</strong> TOEFL/IELTS only if your prior studies weren’t in English.</li><br />
                        <li><strong>Clear finance pathway—</strong> a defined goal in IB, asset management, quant research, or corporate finance.</li><br />
                        <li><strong>Global intakes—</strong> most cohorts begin in September; a few EU and UK schools offer January starts.</li>
                    </ol>
                ),
            },
            {
                title: "MFin vs MFE: Which Finance Master's Is Right for You?",
                description: (
                    <ul style={{ paddingLeft: "1.25rem" }}>
                        <li><strong>Focus:</strong> MFin covers broad finance (valuation, asset management, corporate finance); MFE is quantitative and computational (derivatives, stochastic modelling).</li>
                        <li><strong>Background:</strong> MFin suits finance, economics, or business grads; MFE expects a STEM-heavy profile with strong math.</li>
                        <li><strong>Programming:</strong> useful for MFin; effectively mandatory (Python/R/C++) for MFE.</li>
                        <li><strong>Typical roles:</strong> MFin → investment banking, asset management, corporate finance; MFE → quant trading, quant research, risk.</li>
                        <li><strong>Length:</strong> both run roughly 9–18 months.</li>
                    </ul>
                ),
            },
        ],
        industryBenefitsConfig: {
            headline: "Why choose GradBrew for your MFin or MFE?",
            benefitList: [
                {
                    icon: "/Smart_Profile_Eval.png",
                    title: "Smart Profile Evaluation",
                    description: "Clear, honest, and personalised scorecard of your strengths, gaps, and admit odds— so every next step is targeted.",
                },
                {
                    icon: "/Data_driven_shortlist.png",
                    title: "Data-Driven Shortlist",
                    description: "Dream, target, and safety schools selected by alumni + analytics— no random lists, just ROI-fit options worldwide.",
                },
                {
                    icon: "/Essay_SOP_authentic.png",
                    title: "Fin-Sharp Essays & SOPs",
                    description: "Your draft, our dual-consultant polish. We weave market moves, valuation wins, and coding projects into a story only you can tell.",
                },
                {
                    icon: "/CV_LOR_Support.png",
                    title: "Finance-Ready CV & LOR Kit",
                    description: "Bulletproof résumé with deal metrics, trading P&L, or case comps— plus recommender prompts that hit CFA & leadership keywords.",
                },
                {
                    icon: "/School_style_mock.png",
                    title: "Technical & Behavioral Mock Interviews",
                    description: "Drills on DCF, options Greeks, brain-teasers, and fit questions— mirroring MFin interview banks and quant screens.",
                },
                {
                    icon: "/Dual_Consultant.png",
                    title: "Dual Consultant Review",
                    description: "Two top-school consultants — one leads your application; another ensures pre-final polish. Two sets of eyes, zero weak links.",
                },
                {
                    icon: "/Scholarship_review.png",
                    title: "Scholarship + Extra Doc Review",
                    description: "We fine-tune optional essays, scholarship statements, and any addendum— so every supplemental page works harder for you.",
                },
                {
                    icon: "/Personalised_planner.png",
                    title: "Personalised Planner + Dashboard",
                    description: "Deadlines, drafts, feedback— all tracked in one sleek hub. See exactly what’s due and what’s approved, in real time.",
                },
                {
                    icon: "/Post_admit_guide.png",
                    title: "Post-Admit Guidance",
                    description: "Tips on visas, housing, banking, arrival hacks and settling in— based on your admitted country.",
                },
            ],
        },
        industryFeaturesTitle: "Your GradBrew MFin or MFE Journey — Step by Step",
        industryFeaturesConfig: [
            {
                title: "Kick-off: Complete Your Info Sheet",
                description: (
                    <>
                        A fast,high-signal form that captures your academics, experience, and career goals— fueling every tailored move we make next.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Kickoff infosheet.png",
                    alt: "Complete Your Info Sheet",
                },
            },
            {
                title: "Brainstorming: Strategy Call",
                description: (
                    <>
                        A focused 1-to-1 session with your Lead Consultant to lock school targets, carve your story, clarify goals (e.g., IB or quant trading), and decide which programs and formats align best with your background.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_brainstorming strategy.png",
                    alt: "Brainstorming Call",
                },
            },
            {
                title: "First Drafts: Using Guidance and Smart Tools",
                description: (
                    <>
                        Spin up your first CV, essays, and recommender briefs with smart tools and templates, quick-hit video guides, and tips from your Lead Consultant— all while keeping the voice unmistakably yours.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_first draft.png",
                    alt: "First Drafts Using Smart Tools",
                },
            },
            {
                title: "Consultant Calls and Unlimited Draft Revisions",
                description: (
                    <>
                        Your Lead Consultant deep-dives into your drafts and suggests structured edits. <br /> Team works with you to sharpen structure, language, and impact— until every line earns its spot and still sounds unmistakably you.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Con revision.png",
                    alt: "Consultant Discussion & Revisions",
                },
            },
            {
                title: "Final Review by Second Expert Consultant",
                description: (
                    <>
                        Once near-final, a second expert (also a top-school alum) reviews your entire essays/SOP with fresh eyes for final polishing and strategy alignment. <br /> Back-to-front audit— spotting gaps, sharpening strategy, and adding the final polish before you hit “Submit Application”.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Dual expert review.png",
                    alt: "Dual Expert Review",
                },
            },
            {
                title: "Submit Strong and Nail the Interview",
                description: (
                    <>
                        Application locked. Now we drill for every behavioral and technical question with school-style mock sessions— so you walk in confident and walk out admitted. <br /> Need post-admit help? We’re still on call for visas, housing, and day-one prep.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_nail interview.png",
                    alt: "Submit Strong and Nail the Interview",
                },
            },
        ],
        faqs: [
            {
                category: "Master in Finance (MFin) Basics",
                items: [
                    {
                        question: "What is an MFin degree?",
                        answer: (
                            <>
                                An MFin (Master of Finance) is a specialised, typically one-year pre-experience master&apos;s degree that builds advanced expertise in corporate finance, asset management, valuation, and financial markets. It is aimed at recent graduates and early-career professionals targeting investment banking, private equity, asset management, or corporate finance roles. Top MFin degrees include MIT Sloan, LBS, Princeton (BCF), LSE, and Oxford. GradBrew provides ethical, alumni-led admissions consulting to help you win a place at the right MFin program.
                            </>
                        ),
                    },
                    {
                        question: "What is the MIT Sloan Master of Finance (MFin) acceptance rate?",
                        answer: (
                            <>
                                MIT Sloan&apos;s Master of Finance is one of the most selective finance master&apos;s programs in the world — its acceptance rate is estimated in the high single digits (roughly <strong>5–10%</strong>), with admitted students typically showing very strong quant ability, GRE/GMAT scores, and a sharp finance career story. Because the bar is so high, a precisely targeted application matters: GradBrew&apos;s dual-consultant MFin prep helps you sharpen the technical narrative and stand out to MIT and other top MFin/MFE ad-coms.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Eligibility and Fit",
                items: [
                    {
                        question: "Who should apply for an Master of Finance (MFin) or Master of Financial Engineering (MFE)?",
                        answer: (
                            <>
                                Master of Finance is ideal for students aiming for investment banking, asset management, or corporate finance. <br /><br /> Master of Financial Engineering suits those targeting quant trading, risk modeling, or algorithmic roles — and often requires strong math/programming skills.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply if I don’t have a finance or quant background?",
                        answer: (
                            <>
                                Yes — some MFin programs welcome candidates from economics, business, or even liberal arts if you show strong analytical potential. <br /><br /> For MFE, you’ll need a quant-heavy academic record (e.g., engineering, computer science, physics, economics, etc.).
                            </>
                        ),
                    },
                    {
                        question: "What’s the difference between Master of Finance (MFin) and Master of Financial Engineering (MFE)?",
                        answer: (
                            <>
                                <strong>MFin</strong> focuses on applied finance, investment management, and corporate strategy.<br /><br />
                                <strong>MFE</strong> is more technical, combining math, coding, and financial theory for quant roles.<br /><br />
                                We’ll help you decide which fits your goals and profile.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Application Requirements",
                items: [
                    {
                        question: "Do I need to take the GMAT or GRE?",
                        answer: (
                            <>
                                Most top MFin and MFE programs require either the GMAT or GRE. Some allow waivers, but quant-heavy programs typically prefer strong math scores.
                            </>
                        ),
                    },
                    {
                        question: "What other documents are required?",
                        answer: (
                            <>
                                <ul>
                                    <li>CV/resume</li>
                                    <li>Test scores (GMAT/GRE, TOEFL/IELTS if needed)</li>
                                    <li>Essays/SOPs</li>
                                    <li>Letters of recommendation (LORs)</li>
                                    <li>Academic transcripts</li>
                                    <li>Application form + fee</li>
                                    <li>Additional school-specific requirements</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "Do I need to know programming for Master of Financial Engineering (MFE) programs?",
                        answer: (
                            <>
                                Yes. Master of Financial Engineering (MFE) programs expect comfort with coding — especially in Python, R, or MATLAB. Many also include programming tests or ask about coding projects in interviews.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Timeline and Planning",
                items: [
                    {
                        question: "When should I start preparing my application?",
                        answer: (
                            <>
                                Ideally 2-4 months before target round deadlines. But we’ve supported clients with fast-tracked 3–4 week timelines with focused workflows.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply while still finishing my undergrad degree?",
                        answer: (
                            <>
                                Yes — most programs accept applications from final-year students, as long as your degree is completed before the program starts.
                            </>
                        ),
                    },
                    {
                        question: "How long do MFin and MFE programs usually last?",
                        answer: (
                            <>
                                Typically 10 to 24 months depending on the school. Some offer accelerated or extended tracks.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Cost and Scholarships",
                items: [
                    {
                        question: "What’s the tuition cost for MFin/MFE programs?",
                        answer: (
                            <>
                                Costs range from $50,000 to $120,000 depending on the school and country. European programs tend to be more affordable than US options.
                            </>
                        ),
                    },
                    {
                        question: "Are scholarships available?",
                        answer: (
                            <>
                                Yes — most top schools offer merit- and need-based scholarships. Applying early and telling a compelling story helps improve chances. There are also several scholarships outside school offered by some organisations.
                            </>
                        ),
                    },
                    {
                        question: "Can GradBrew help with scholarship essays?",
                        answer: (
                            <>
                                Yes. Scholarship support is included in all packages — we help connect your goals and background to the school’s impact themes.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Career Outcomes and Interviews",
                items: [
                    {
                        question: "What careers can I pursue after MFin or MFE?",
                        answer: (
                            <>
                                <strong>Master in Finance (MFin):</strong> Investment banking, asset management, private equity, corporate finance, etc.<br />
                                <strong>Master in Financial Engineering (MFE):</strong> Quant trading, risk modeling, data science, fintech product roles, etc.
                            </>
                        ),
                    },
                    {
                        question: "What is the interview process like?",
                        answer: (
                            <>
                                Master of Financial Engineering (MFE) interviews often include technical or programming questions. <br /> MFin interviews focus on behavioral fit, career goals, and financial reasoning. We help you prep for both types.
                            </>
                        ),
                    },
                    {
                        question: "How strong are job placements for MFin or MFE programs?",
                        answer: (
                            <>
                                Top schools have strong placement records, especially into finance hubs like NYC, London, Singapore. Career services, alumni networks, and visa rules also play a big role.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "GradBrew Support",
                items: [
                    {
                        question: "Can GradBrew help me choose between MFin and MFE?",
                        answer: (
                            <>
                                Yes. During your initial strategy call, we evaluate your profile, strengths, and career goals to suggest the best path forward — and the best-fit programs globally.
                            </>
                        ),
                    },
                    {
                        question: "Do you help with coding tests or quant interview questions?",
                        answer: (
                            <>
                                We provide practice resources, prep strategies, and interview frameworks to candidates. If needed, we can guide you to top-tier technical prep platforms as well.
                            </>
                        ),
                    },
                    {
                        question: "How is your support different from other consultants?",
                        answer: (
                            <>
                                <ul>
                                    <li>Ethical consulting — no ghostwriting</li>
                                    <li>Two expert consultants (a Lead Consultant and a Second Expert) reviews application before you submit</li>
                                    <li>AI-assisted planning tools and feedback</li>
                                    <li>Clear dashboards and flexible timelines</li>
                                </ul>
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Program Requirements and Structure",
                items: [
                    {
                        question: "Do I need a finance degree to apply for a Master of Financial Engineering (MFE)?",
                        answer: (
                            <>
                                No. Most Master of Financial Engineering (MFE) applicants come from math, physics, engineering, statistics, economics, or computer science backgrounds. What matters is your quantitative and analytical strength, not a finance degree.
                            </>
                        ),
                    },
                    {
                        question: "What technical skills do top Master of Financial Engineering (MFE) programs look for?",
                        answer: (
                            <>
                                Top programs expect:
                                <ul>
                                    <li>Strong math (linear algebra, calculus, probability, stochastic processes)</li>
                                    <li>Programming proficiency (Python is most common; R, MATLAB, or C++ also valued)</li>
                                    <li>Comfort with data analysis and modeling</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "How can I prove my quant skills if I don’t have a math-heavy degree?",
                        answer: (
                            <>
                                You can strengthen your application with:
                                <ul>
                                    <li>High GMAT/GRE quant scores</li>
                                    <li>Online certifications in probability, Python, or machine learning</li>
                                    <li>Quantitative research, projects, or internships</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "Are there coding or math tests as part of the Master of Financial Engineering (MFE) admissions process?",
                        answer: (
                            <>
                                Yes — some programs include technical assessments or coding tasks. Others may ask quant questions during interviews.
                            </>
                        ),
                    },
                    {
                        question: "What’s the difference between Master of Financial Engineering (MFE) and MS in Quant Finance/Financial Math?",
                        answer: (
                            <>
                                They’re often used interchangeably. However:<br />
                                <strong>Master of Financial Engineering (MFE)</strong> tends to be more industry-focused (trading, quant roles)<br />
                                <strong>MSFM or MSQF</strong> may lean more academic or theoretical<br />
                                Each school brands it differently — we help you navigate which fits your path.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply for an Master of Financial Engineering (MFE) without work experience?",
                        answer: (
                            <>
                                Yes. Many Master of Financial Engineering (MFE) programs are designed for students with strong academic profiles and 0–2 years of experience. Research or internships in finance or analytics are a bonus.
                            </>
                        ),
                    },
                    {
                        question: "Are there part-time or online Master of Financial Engineering (MFE) options?",
                        answer: (
                            <>
                                Very few. Most Master of Financial Engineering (MFE) programs are full-time and highly intensive, often with internship components or capstone projects.
                            </>
                        ),
                    },
                ],
            },
        ],
        ctaConfig: {
            title: "Ready to Power Up Your MFin or MFE Journey with GradBrew?",
            description: `
                 <ul>
                    <li><strong>Quant-tuned game plan</strong> – dual-consultant guidance, AI tools, and a live dashboard that tracks every step from first draft to admit.</li><br/>
                    <li><strong>Ethical edge</strong> – no ghostwriting or generic templates; just your authentic finance story, sharpened for top MFin & MFE ad-coms.</li><br/>
                    <li><strong>Technical-proof confidence</strong> – brain-teaser and valuation mock interviews, plus scholarship & test-waiver positioning.</li><br/>
                    <li><strong>Post-admit peace of mind</strong> – visa, housing, and pre-arrival quant prep, plus early Career Studio access for internship leads (add-on).</li><br/><br/>
                  </ul>`,
            buttons: [
                { href: "#pricing-plan", text: "Pricing", className: "button is-large w-button" },
                { href: "#why-us", text: "Why US?", className: "button-outline is-large w-button" }
            ]
        }
    },
    'master-in-management': {
        pricingKey: "MIM",
        pricingTitle: "Tailored made pricing plans for your MiM journey",
        productHomeHeroConfig: {
            title: "Launch your Global Career with a top Master in Management",
            subtitle: `Break into LBS, HEC, INSEAD, and beyond— no full-time work experience required`,
            description: "A Master in Management (MiM) is a pre-experience master's degree for final-year students and recent graduates with 0–3 years of experience. GradBrew helps you win places at top MiM programs like LBS, HEC Paris, and INSEAD — with <strong>tailored strategy, ethical guidance, and insider mentorship</strong>, often with no GMAT or full-time work experience required.",

            heroImage: {
                src: "/MiM header pic.png",
                alt: "GradBrew Master in Management"
            },
            brandsTitle: "Where Our Mentors Come From & Our Clients Get In",
            ctas: ctas,
            brands: [
                {
                    src: "/Homepage_Chicago Booth Logo.jpeg",
                    alt: "The University of Chicago Booth School of Business"
                },
                {
                    src: "/Homepage_headerimg_LBS logo.jpg",
                    alt: "London Business School"
                },
                {
                    src: "/Homepage_headerimg_Insead logo.webp",
                    alt: "INSEAD"
                },
                {
                    src: "/Homepage_headerimg ESCP logo.png",
                    alt: "ESCP Business School"
                },
                {
                    src: "/Homepage_headerimg_HEC_Paris logo.png",
                    alt: "HEC Paris"
                },
                {
                    src: "/IE _logo_og.png",
                    alt: "IE Business School"
                },
                {
                    src: "/NUS_logo_og.png",
                    alt: "National University of Singapore"
                },
                {
                    src: "/RSM_logo_og.png",
                    alt: "Rotterdam School of Management, Erasmus University"
                },
                // {
                //     src: "/WHU_Logo.png",
                //     alt: "WHU – Otto Beisheim School of Management"
                // }
            ]
        },
        industrySolutionsConfig: [
            {
                title: "MiM at a Glance",
                description: (
                    <>
                        <li><strong>Target audience:</strong> Final-year students and recent graduates with 0–3 years of experience who want a head start in global business.</li><br />
                        <li><strong>Core focus:</strong> Management fundamentals, analytics, cross-cultural teamwork, and built-in internship tracks that add real experience fast.</li><br />
                        <li><strong>Career outcomes:</strong> Launch roles in consulting, corporate finance, rotational leadership programs, marketing, and business analytics.</li><br />
                        <li><strong>Degree format:</strong> A 10- to 24-month pre-experience master that mixes case studies, company projects, and global study tours.</li><br />
                        <li><strong>Network effect:</strong> Early access to a top-tier alumni network and campus recruiters— opening doors before you’ve even hit year one on the job.</li>
                    </>
                ),
            },
            {
                title: "Who Should Apply?",
                description: (
                    <ol style={{ paddingLeft: "0" }}>
                        <li><strong>0–3 years experience—</strong> solid internships, campus leadership, or project wins that hint at future potential.</li><br />
                        <li><strong>Fresh bachelor’s (any major)—</strong> strong GPA is key; STEM or business backgrounds get a small edge but aren’t required.</li><br />
                        <li><strong>GMAT / GRE optional—</strong> a GMAT 655+ or GRE 325+ helps, yet many schools waive scores for high GPAs or STEM degrees.</li><br />
                        <li><strong>English-ready—</strong> TOEFL/IELTS only if your degree wasn’t taught in English.</li><br />
                        <li><strong>Early-career vision—</strong> a clear “Why MiM” and how it jump-starts consulting, finance, or analytics goals.</li><br />
                        <li><strong>Global intakes—</strong> most cohorts start September; a few schools offer January or April options.</li>
                    </ol>
                ),
            },
            {
                title: "MiM vs MBA: Which Should You Apply To?",
                description: (
                    <ul style={{ paddingLeft: "1.25rem" }}>
                        <li><strong>Experience:</strong> MiM suits 0–3 years (pre-experience); an MBA suits 3–5+ years.</li>
                        <li><strong>Best for:</strong> MiM fits final-year students and recent graduates; an MBA fits mid-career professionals.</li>
                        <li><strong>Length:</strong> MiM runs 10–24 months; an MBA runs 12–24 months.</li>
                        <li><strong>Admissions test:</strong> MiM often makes the GMAT/GRE optional or waivable; an MBA usually expects it.</li>
                        <li><strong>Goal:</strong> A MiM launches your global career; an MBA accelerates or pivots an established one.</li>
                    </ul>
                ),
            },
        ],
        industryBenefitsConfig: {
            headline: "Why choose GradBrew for your MiM?",
            benefitList: [
                {
                    icon: "/Smart_Profile_Eval.png",
                    title: "Smart Profile Evaluation",
                    description: "Clear, honest, and personalised scorecard of your strengths, gaps, and admit odds— so every next step is targeted.",
                },
                {
                    icon: "/Data_driven_shortlist.png",
                    title: "Data-Driven Shortlist",
                    description: "Dream, target, and safety schools selected by alumni + analytics— no random lists, just ROI-fit options worldwide.",
                },
                {
                    icon: "/Essay_SOP_authentic.png",
                    title: "Essays and SOPs — Real YOU",
                    description: "You draft (or AI-draft), we sharpen. Passes by two expert consultants ensure voice, impact, and ethical polish.",
                },
                {
                    icon: "/CV_LOR_Support.png",
                    title: "CV and LOR support",
                    description: "Global MiM-standard résumé makeover and step-by-step guidance for recommenders to hit leadership keywords.",
                },
                {
                    icon: "/School_style_mock.png",
                    title: "School-Style Mock Interviews",
                    description: "Personal, video, and group case drills that mirror each program’s format—real-time feedback, real confidence.",
                },
                {
                    icon: "/Dual_Consultant.png",
                    title: "Dual Consultant Review",
                    description: "Lead Consultant shapes strategy; second top-school expert gives the pre-submit once-over. Two sets of eyes, zero weak links.",
                },
                {
                    icon: "/Scholarship_review.png",
                    title: "Scholarship + Extra Doc Review",
                    description: "We fine-tune optional essays, scholarship statements, and any addendum— so every supplemental page works harder for you.",
                },
                {
                    icon: "/Personalised_planner.png",
                    title: "Personalised Planner + Dashboard",
                    description: "Deadlines, drafts, feedback— all tracked in one sleek hub. See exactly what’s due and what’s approved, in real time.",
                },
                {
                    icon: "/Post_admit_guide.png",
                    title: "Post-Admit Guidance",
                    description: "Tips on visas, housing, banking, arrival hacks and settling in— based on your admitted country.",
                },
            ]
        },
        industryFeaturesTitle: "Your GradBrew MiM Journey — Step by Step",
        industryFeaturesConfig: [
            {
                title: "Kick-off: Complete Your Info Sheet",
                description: (
                    <>
                        A fast,high-signal form that captures your academics, experience, and career goals— fueling every tailored move we make next.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Kickoff infosheet.png",
                    alt: "Complete Your Info Sheet",
                },
            },
            {
                title: "Brainstorming: Strategy Call",
                description: (
                    <>
                        A focused 1-to-1 session with your Lead Consultant to lock school targets, carve your story arc, and pinpoint what makes you stand out.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_brainstorming strategy.png",
                    alt: "Brainstorming Call",
                },
            },
            {
                title: "First Drafts: Using Guidance and Smart Tools",
                description: (
                    <>
                        Spin up your first CV, essays, and recommender briefs with smart tools and templates, quick-hit video guides, and tips from your Lead Consultant— all while keeping the voice unmistakably yours.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_first draft.png",
                    alt: "First Drafts Using Smart Tools",
                },
            },
            {
                title: "Consultant Calls and Unlimited Draft Revisions",
                description: (
                    <>
                        Your Lead Consultant deep-dives into your drafts and suggests structured edits. Team works with you to sharpen structure, language, and impact—until every line earns its spot and still sounds unmistakably you.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Con revision.png",
                    alt: "Consultant Discussion & Revisions",
                },
            },
            {
                title: "Final Review by Second Expert Consultant",
                description: (
                    <>
                        Once near-final, a second expert (also a top-school alum) reviews your entire essays/SOP with fresh eyes for final polishing and strategy alignment. Back-to-front audit— spotting gaps, sharpening strategy, and adding the final polish before you hit “submit”.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Dual expert review.png",
                    alt: "Dual Expert Review",
                },
            },
            {
                title: "Submit Strong and Nail the Interview",
                description: (
                    <>
                        Application locked. Now we drill for every behavioral and technical question with school-style mock sessions— so you walk in confident and walk out admitted. <br /> Need post-admit help? We’re still on call for visas, housing, and day-one prep.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_nail interview.png",
                    alt: "Submit Strong and Nail the Interview",
                },
            },
        ],
        faqs: [
            {
                category: "MiM Admissions Consulting",
                items: [
                    {
                        question: "What does a MiM admissions consultant do?",
                        answer: (
                            <>
                                A MiM admissions consultant helps you build a competitive Master in Management application end to end — school shortlisting, essay strategy and editing, CV, recommendations, and interview prep. At GradBrew, MiM admissions consulting pairs you with two consultants (a lead alum from a top MiM program plus a second reviewer) so every document gets dual feedback. It is 100% ethical: we coach and edit, we never ghostwrite, so the application still sounds like you.
                            </>
                        ),
                    },
                    {
                        question: "Which one-year MiM programs are best for a consulting career?",
                        answer: (
                            <>
                                For graduates targeting consulting, the strongest one-year Master in Management programs include <strong>LBS MiM, HEC Paris MiM, INSEAD MiM, ESADE, and St. Gallen (SIM)</strong>, all of which have deep MBB and Big-4 recruiting pipelines. The right pick depends on your profile, target geography, and budget — GradBrew&apos;s MiM consultants build a personalised shortlist (dream, target, and safe schools) so you apply where your consulting goals and admit odds actually line up.
                            </>
                        ),
                    },
                    {
                        question: "How much does MiM prep / MiM admissions consulting cost?",
                        answer: (
                            <>
                                GradBrew&apos;s MiM prep is priced by the number of schools you apply to — starting at INR 79,000 for a 2-school plan, INR 129,000 for the popular 4-school plan, up to INR 209,000 for 8 schools, with unlimited edits and dual-consultant mentorship included. See what&apos;s included in our <Link href="/mim-prep">MiM prep guide</Link>, or calculate your exact MiM prep price on our <Link href="/pricing" target="_blank">pricing page</Link>.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Eligibility and Admissions",
                items: [
                    {
                        question: "Who is eligible to apply for a MiM program?",
                        answer: (
                            <>
                                MiM programs are open to candidates with a bachelor’s degree in any discipline — including business, engineering, science, arts, or law. Most programs are designed for early-career professionals and typically accept applicants with 0–3 years of full-time work experience by the time they start the program — not at the time of application.<br /><br />
                                For example, if a program allows up to 24 months of experience and you apply in November 2025 for a Fall 2026 intake, your work experience will be counted up to May/June 2026, not November 2025. This gives many final-year students or recent graduates a viable window to apply.
                            </>
                        ),
                    },
                    {
                        question: "Is prior work experience required for MiM applications?",
                        answer: (
                            <>
                                Not at all. MiM is designed for fresh graduates or early professionals. In fact, many programs limit experience to under 2–3 years.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply if my undergraduate degree is not in business or economics?",
                        answer: (
                            <>
                                Yes! MiM programs value diversity. Many top programs actively encourage applicants from non-business backgrounds.
                            </>
                        ),
                    },
                    {
                        question: "What are the typical academic requirements (GPA, degree type)?",
                        answer: (
                            <>
                                Requirements vary. A strong academic record helps, but schools also assess your story, goals, and potential. Most accept any recognized undergraduate degree.
                            </>
                        ),
                    },
                    {
                        question: "Do I need to submit GMAT or GRE scores? Are there waivers available?",
                        answer: (
                            <>
                                Some top European schools require GMAT/GRE. Some French schools accept CAT (Common Admission Test) also. Others have optional requirements or offer waivers based on academics. We’ll help you decide whether to take it based on your school list and profile.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Application Components",
                items: [
                    {
                        question: "What documents are required for the application?",
                        answer: (
                            <>
                                Your application usually includes:
                                <ul>
                                    <li>CV/resume</li>
                                    <li>Test scores (GMAT/GRE, TOEFL/IELTS if needed)</li>
                                    <li>Essays/SOPs</li>
                                    <li>Letters of recommendation (LORs)</li>
                                    <li>Academic transcripts</li>
                                    <li>Application form + fee</li>
                                    <li>Additional school-specific requirements</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "How important are essays and the Statement of Purpose (SOP)?",
                        answer: (
                            <>
                                Very important. They show your motivation, goals, and fit. We’ll help you write compelling and authentic essays — in your voice, never ghostwritten.
                            </>
                        ),
                    },
                    {
                        question: "What should I include in my CV/resume for MiM applications?",
                        answer: (
                            <>
                                Your resume should highlight academics, internships, projects, leadership roles, extracurriculars, and achievements — all in a global, business-school format.
                            </>
                        ),
                    },
                    {
                        question: "How many letters of recommendation are needed, and who should write them?",
                        answer: (
                            <>
                                Usually one or two. Ideal recommenders are professors, internship supervisors, or recent managers who know your work well.
                            </>
                        ),
                    },
                    {
                        question: "Are there specific formats or guidelines for these documents?",
                        answer: (
                            <>
                                Yes. Most schools provide prompts and formatting rules — and we’ll help you tailor every document accordingly.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Timeline and Process",
                items: [
                    {
                        question: "When should I start preparing for my MiM application?",
                        answer: (
                            <>
                                Ideally 2-4 months before target round deadlines. But we’ve supported clients with fast-tracked 3–4 week timelines with focused workflows.
                            </>
                        ),
                    },
                    {
                        question: "What are the typical application deadlines?",
                        answer: (
                            <>
                                Most deadlines run from August to April, depending on the school and intake (Fall/Spring). Applying earlier often gives better scholarship chances.<br /> Round 1 and 2 (Aug–Jan) are preferred. Round 3 is a bit competitive but can work for strong profiles or regional schools. Some schools have specific round deadlines for international applicants.
                            </>
                        ),
                    },
                    {
                        question: "How long does the entire application process take?",
                        answer: (
                            <>
                                On average, 4–6 weeks from first draft to final submission. Longer if you're applying to many schools or preparing for GMAT/GRE.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply to multiple schools simultaneously?",
                        answer: (
                            <>
                                Absolutely. We’ll help you organize timelines and tailor each application for maximum impact.
                            </>
                        ),
                    },
                    {
                        question: "What is the interview process like, and how can I prepare?",
                        answer: (
                            <>
                                Most interviews are behavioral and school-specific. You’ll get mock session for each school you apply with us — including feedback from your Consultant.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Financing and Scholarships",
                items: [
                    {
                        question: "What is the average cost of a MiM program?",
                        answer: (
                            <>
                                Tuition ranges from €20,000 to €50,000, depending on the school. Living costs vary by location — Europe is generally more affordable than the US. Some schools may have lower tuition fees as well depending on program duration.
                            </>
                        ),
                    },
                    {
                        question: "Are scholarships or financial aid options available?",
                        answer: (
                            <>
                                Yes, many top schools offer merit-based or need-based scholarships. A strong application and early submission improve your chances. <br /> Apply early, highlight your achievements, and match your story to the school’s values and impact goals. We’ll help you frame this right.
                            </>
                        ),
                    },
                    {
                        question: "What are the living expenses associated with studying abroad?",
                        answer: (
                            <>
                                Expect €800–€1,200/month in Europe and $1,200–$2,000/month in the US. It varies with countries.
                            </>
                        ),
                    },
                    {
                        question: "Can I work part-time while enrolled in a MiM program?",
                        answer: (
                            <>
                                Yes, some countries allow it. For instance, in Germany, students can work ~20 hours/week as a working student in companies. In the US, restrictions apply but on-campus jobs are common.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Post-Admit and Career Outcomes",
                items: [
                    {
                        question: "What career opportunities are available after completing a MiM?",
                        answer: (
                            <>
                                Graduates go into consulting, finance, marketing, tech, luxury, and startups. Roles include business analyst, strategy associate, project manager, and more.
                            </>
                        ),
                    },
                    {
                        question: "How does a MiM differ from an MBA in terms of career prospects?",
                        answer: (
                            <>
                                MiM is for early-career candidates; MBA is for experienced professionals. MiM offers strong entry-level jobs and a foundation for future MBAs or promotions.
                            </>
                        ),
                    },
                    {
                        question: "Can I pursue further studies, like an MBA, after a MiM?",
                        answer: (
                            <>
                                Yes. Many MiM grads pursue an MBA later in their career — especially once they’ve gained 4–5 years of experience.
                            </>
                        ),
                    },
                    {
                        question: `What support does ${siteSettings.siteName} offer post-admission?`,
                        answer: (
                            <>
                                We provide tips and guidance on visas, accommodation, financial planning, and settling in — school- and country-specific. Please note, we do not provide these services in-house.
                            </>
                        ),
                    },
                    {
                        question: "How do MiM programs support international students in job placements?",
                        answer: (
                            <>
                                Top programs offer dedicated career services, job fairs, employer networking, and visa/job search support — especially in Europe.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "About Fit and School Choice",
                items: [
                    {
                        question: "Is MiM better suited for career switchers or business-focused students?",
                        answer: (
                            <>
                                Both. It helps non-business grads enter business, and accelerates business grads' careers through a global platform.
                            </>
                        ),
                    },
                    {
                        question: "How does MiM compare to MS in Management or MS in Business Analytics?",
                        answer: (
                            <>
                                MiM is broader and more leadership-focused. MSBA is highly technical/data-driven. We help you choose based on your goals.
                            </>
                        ),
                    },
                    {
                        question: "Should I pursue MiM if I already have a few years of experience?",
                        answer: (
                            <>
                                If you have over 2.5–3 years of experience, an MBA or specialised masters might be more appropriate. We’ll guide you to the right choice.
                            </>
                        ),
                    }
                ],
            },
            {
                category: "GradBrew-Specific FAQs",
                items: [
                    {
                        question: `What makes ${siteSettings.siteName}’s process different from other consultants?`,
                        answer: (
                            <>
                                We combine expert guidance, AI tools, and your ownership. No ghostwriting. Dual consultant review. Transparent pricing. Ethical results.
                            </>
                        ),
                    },
                    {
                        question: "Will my application be written by consultants or do I write it myself?",
                        answer: (
                            <>
                                You write it — using AI tools, our dashboard resources and consultant's guidance. Then our consultants refine it collaboratively with you.
                            </>
                        ),
                    },
                    {
                        question: "How is AI used in your process?",
                        answer: (
                            <>
                                To help you draft faster, identify content gaps, and get instant feedback. Human consultants handle strategy and fine-tuning.
                            </>
                        ),
                    },
                    {
                        question: "How many consultants will work with me during the process?",
                        answer: (
                            <>
                                Two: your Lead Consultant (from a top B-school) and a Final Reviewer (another expert who sees your near-final drafts).
                            </>
                        ),
                    },
                    {
                        question: "Can I book a one-time consultation instead of a full package?",
                        answer: (
                            <>
                                Yes, we offer profile evaluations, interview prep, and one-time feedback sessions. Ideal if you just need guidance, not full help. Please contact MiM@gradbrew.com for more details.
                            </>
                        ),
                    },
                    {
                        question: "How long does the editing and feedback cycle typically take?",
                        answer: (
                            <>
                                First feedback is typically delivered within 2–4 days. Final reviews follow after your revisions. Timelines are always customized to your deadlines.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Test-Related FAQs",
                items: [
                    {
                        question: "Is GMAT required for all MiM programs?",
                        answer: (
                            <>
                                No. Many top European schools (like HEC Paris, ESCP, ESSEC, Rotterdam) have test-optional or flexible policies.
                            </>
                        ),
                    },
                    {
                        question: "Can I apply before taking the GMAT/GRE?",
                        answer: (
                            <>
                                Yes, many schools allow you to submit applications and send scores later — we help you prioritize accordingly.
                            </>
                        ),
                    },
                    {
                        question: "Which programs are test-optional or test-flexible?",
                        answer: (
                            <>
                                Most European MiMs are test-optional if you have a strong GPA. US MiMs often require GMAT/GRE. We’ll give you a school-specific list.
                            </>
                        ),
                    },
                    {
                        question: "What are good GMAT/GRE scores for top MiM programs?",
                        answer: (
                            <>
                                Generally, 625+ GMAT or 325+ GRE. But holistic strength matters more. We’ll help you apply strategically — with or without scores.
                            </>
                        ),
                    },
                ],
            },
        ],
        ctaConfig: {
            title: "Ready to Launch Your MiM Journey with GradBrew?",
            description: ` 
                <ul>
                    <li><strong>Early-career game plan</strong> – dual-consultant strategy turns academics, internships, and extracurriculars into a standout MiM profile.</li><br/>
                    <li><strong>AI-boosted, human-first</strong> – smart templates plus alumni insight craft essays in your own voice—never ghostwritten or cookie-cutter.</li><br/>
                    <li><strong>Quant & fit readiness</strong> – GMAT/GRE guidance, résumé redesign, and school-style interview drills that highlight analytical potential.</li><br/>
                    <li><strong>Scholarship & waiver edge</strong> – targeted essay tweaks and document sets to win tuition discounts and merit aid.</li><br/>
                    <li><strong>Post-admit launch</strong> – visa, housing, and optional access to our Career Studio platform for internship prep before you hit campus.</li><br/><br/>
                </ul>`,
            buttons: [
                { href: "#pricing-plan", text: "Pricing", className: "button is-large w-button" },
                { href: "#why-us", text: "Why US?", className: "button-outline is-large w-button" }
            ]
        }
    },
    'master-in-marketing': {
        pricingKey: "MARKETING",
        pricingTitle: "Tailored made pricing plans for your MS in Marketing journey",
        productHomeHeroConfig: {
            title: "Ignite Your Global Marketing Career with a Top MS in Marketing",
            subtitle: `Break into Columbia, NYU, ESADE, ESCP, and beyond— on the strength of your ideas`,
            description: "A Master in Marketing (MS in Marketing) is a 9–18 month pre-experience master's for students and recent graduates (0–3 years) who want roles in brand, growth, digital, or product marketing. GradBrew helps you get into programs like Columbia, NYU, and ESADE — with <strong>data-driven positioning, ethical storytelling, and alumni mentorship</strong>.",

            heroImage: {
                src: "/GradBrew MS Marketing header.png",
                alt: "GradBrew MS in Marketing"
            },
            brandsTitle: "Where Our Mentors Come From & Our Clients Get In",
            ctas: ctas,
            brands: [
                {
                    src: "/Homepage_headerimg ESCP logo.png",
                    alt: "ESCP Business School"
                },
                {
                    src: "/Homepage_headerimg_HEC_Paris logo.png",
                    alt: "HEC Paris"
                },
                {
                    src: "/IE _logo_og.png",
                    alt: "IE Business School"
                },
                {
                    src: "/Esade_logo_og.png",
                    alt: "Esade Business School"
                },
                {
                    src: "/USC_Marshall_logo.png",
                    alt: "USC Marshall School of Business"
                },
                {
                    src: "/Columbia bs logo.png",
                    alt: "Columbia Business School"
                },
                {
                    src: "/Homepage_UTexas Austin Logo.png",
                    alt: "The University of Texas at Austin"
                },
                {
                    src: "/RSM_logo_og.png",
                    alt: "Rotterdam School of Management, Erasmus University"
                },
                {
                    src: "/University_of_Michigan_Logo_og.png",
                    alt: "University of Michigan"
                }
            ]
        },
        industrySolutionsConfig: [
            {
                title: "MS in Marketing at a Glance",
                description: (
                    <>
                        <li><strong>Target audience:</strong> Final-year students and recent grads with 0–3 years’ exposure to marketing, media, or analytics who want a specialised edge.</li><br />
                        <li><strong>Core focus:</strong> Consumer psychology, brand storytelling, digital & social analytics, and omni-channel strategy—backed by live client projects.</li><br />
                        <li><strong>Career outcomes:</strong> Entry roles in brand management, growth/digital marketing, luxury marketing, market research, and product marketing at tech and FMCG giants.</li><br />
                        <li><strong>Degree format:</strong> A 9- to 18-month pre-experience programme that blends case studies, agency simulations, and real campaigns for global brands.</li><br />
                        <li><strong>Network effect:</strong> Early access to alumni and recruiters from top agencies and Fortune 500 brands—plus company treks and mentor matching before graduation.</li>
                    </>
                ),
            },
            {
                title: "Who Should Apply?",
                description: (
                    <ol style={{ paddingLeft: "0" }}>
                        <li><strong>0–3 years’ experience—</strong> marketing or media internships, campus campaigns, or content projects that show creative drive.</li><br />
                        <li><strong>Bachelor’s in any major—</strong> business, communications, psychology, STEM, or arts; a solid GPA and curiosity about consumer behaviour matter most.</li><br />
                        <li><strong>GMAT/GRE flexible—</strong> 650+/320+ strengthens your case, but many MS Marketing programs waive scores for high GPAs or strong portfolios.</li><br />
                        <li><strong>Portfolio advantage—</strong> social-media campaigns, case-competition wins, or branding projects give you an extra edge.</li><br />
                        <li><strong>English-ready—</strong> TOEFL/IELTS only if your previous degree wasn’t taught in English.</li><br />
                        <li><strong>Global intakes—</strong> most cohorts start in August/September; select schools offer January or April options.</li>
                    </ol>
                ),
            },
            {
                title: "MS in Marketing vs an MBA: Which Fits Your Goals?",
                description: (
                    <ul style={{ paddingLeft: "1.25rem" }}>
                        <li><strong>Depth vs breadth:</strong> an MS in Marketing goes deep on brand, digital, and consumer analytics; an MBA offers broad general management with a marketing track.</li>
                        <li><strong>Experience:</strong> an MS suits 0–3 years (pre-experience); an MBA suits 3–8+ years.</li>
                        <li><strong>Length:</strong> an MS runs 9–18 months; an MBA runs 10–24 months.</li>
                        <li><strong>Roles:</strong> MS → brand, growth, or product-marketing specialist; MBA → marketing manager or leadership track.</li>
                        <li><strong>Admissions test:</strong> MS programs often waive the GMAT/GRE for strong GPAs or portfolios; MBAs usually expect it.</li>
                    </ul>
                ),
            },
        ],
        industryBenefitsConfig: {
            headline: "Why choose GradBrew for your Master in Marketing?",
            benefitList: [
                {
                    icon: "/Smart_Profile_Eval.png",
                    title: "Smart Profile Evaluation",
                    description: "Clear, honest, and personalised scorecard of your strengths, gaps, and admit odds— so every next step is targeted.",
                },
                {
                    icon: "/Data_driven_shortlist.png",
                    title: "Data-Driven Shortlist",
                    description: "Dream, target, and safety schools selected by alumni + analytics— no random lists, just ROI-fit options worldwide.",
                },
                {
                    icon: "/Essay_SOP_authentic.png",
                    title: "Essays and SOPs — Real YOU",
                    description: "You draft (or AI-draft), we sharpen. Passes by two expert consultants ensure voice, impact, and ethical polish.",
                },
                {
                    icon: "/CV_LOR_Support.png",
                    title: "CV and LOR support",
                    description: "Global MS Marketing-standard résumé makeover and step-by-step guidance for recommenders to hit leadership keywords.",
                },
                {
                    icon: "/School_style_mock.png",
                    title: "School-Style Mock Interviews",
                    description: "Personal, video, and group case drills that mirror each program’s format—real-time feedback, real confidence.",
                },
                {
                    icon: "/Dual_Consultant.png",
                    title: "Dual Consultant Review",
                    description: "Lead Consultant shapes strategy; second top-school expert gives the pre-submit once-over. Two sets of eyes, zero weak links.",
                },
                {
                    icon: "/Scholarship_review.png",
                    title: "Scholarship + Extra Doc Review",
                    description: "We fine-tune optional essays, scholarship statements, and any addendum— so every supplemental page works harder for you.",
                },
                {
                    icon: "/Personalised_planner.png",
                    title: "Personalised Planner + Dashboard",
                    description: "Deadlines, drafts, feedback— all tracked in one sleek hub. See exactly what’s due and what’s approved, in real time.",
                },
                {
                    icon: "/Post_admit_guide.png",
                    title: "Post-Admit Guidance",
                    description: "Tips on visas, housing, banking, arrival hacks and settling in— based on your admitted country.",
                },
            ],
        },
        industryFeaturesTitle: "Your GradBrew MS in Marketing Journey — Step by Step",
        industryFeaturesConfig: [
            {
                title: "Kick-off: Complete Your Info Sheet",
                description: (
                    <>
                        A fast,high-signal form that captures your academics, experience, and career goals— fueling every tailored move we make next.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Kickoff infosheet.png",
                    alt: "Complete Your Info Sheet",
                },
            },
            {
                title: "Brainstorming: Strategy Call",
                description: (
                    <>
                        A focused 1-to-1 session with your Lead Consultant to lock school targets, carve your story arc, and pinpoint what makes you stand out.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_brainstorming strategy.png",
                    alt: "Brainstorming Call",
                },
            },
            {
                title: "First Drafts: Using Guidance and Smart Tools",
                description: (
                    <>
                        Spin up your first CV, essays, and recommender briefs with smart tools and templates, quick-hit video guides, and tips from your Lead Consultant— all while keeping the voice unmistakably yours.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_first draft.png",
                    alt: "First Drafts Using Smart Tools",
                },
            },
            {
                title: "Consultant Calls and Unlimited Draft Revisions",
                description: (
                    <>
                        Your Lead Consultant deep-dives into your drafts and suggests structured edits. Team works with you to sharpen structure, language, and impact— until every line earns its spot and still sounds unmistakably you.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Con revision.png",
                    alt: "Consultant Discussion & Revisions",
                },
            },
            {
                title: "Final Review by Second Expert Consultant",
                description: (
                    <>
                        Once near-final, a second expert (also a top-school alum) reviews your entire essays/SOP with fresh eyes for final polishing and strategy alignment. Back-to-front audit— spotting gaps, sharpening strategy, and adding the final polish before you hit “submit”.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Dual expert review.png",
                    alt: "Dual Expert Review",
                },
            },
            {
                title: "Submit Strong and Nail the Interview",
                description: (
                    <>
                        Application locked. Now we drill for every behavioral and technical question with school-style mock sessions— so you walk in confident and walk out admitted. <br /> Need post-admit help? We’re still on call for visas, housing, and day-one prep.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_nail interview.png",
                    alt: "Submit Strong and Nail the Interview",
                },
            },
        ],
        faqs: [
            {
                category: "Eligibility and Background",
                items: [
                    {
                        question: "Who can apply for a MS in Marketing program?",
                        answer: (
                            <>
                                Anyone with a completed bachelor’s degree—business, STEM, arts, or humanities—can apply. Most programs target final-year students or recent graduates with 0–3 years of work experience, plus internships or projects that show marketing or analytical potential.
                            </>
                        ),
                    },
                    {
                        question: "Do I need work experience?",
                        answer: (
                            <>
                                Most programs are open to applicants without full-time work experience. However, internships, projects, or domain exposure can strengthen your profile — especially for competitive programs.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Application and Documents",
                items: [
                    {
                        question: "What documents do I need to apply?",
                        answer: (
                            <>
                                Your application usually includes:
                                <ul>
                                    <li>CV/resume</li>
                                    <li>Test scores (GMAT/GRE, TOEFL/IELTS if needed)</li>
                                    <li>Essays/SOPs</li>
                                    <li>Letters of recommendation (LORs)</li>
                                    <li>Academic transcripts</li>
                                    <li>Application form + fee</li>
                                    <li>Additional school-specific requirements</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "Do I need GMAT or GRE for Masters in Marketing?",
                        answer: (
                            <>
                                Some programs require it — especially in the US and for highly competitive tracks. Many top programs are test-optional or waive scores for strong GPAs or portfolios, but a 615+ GMAT / 322+ GRE can boost scholarships and offset weak quant grades.<br /> Always check each school’s current policy before deciding. We help you decide whether to apply with or without scores.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Program Outcomes and Fit",
                items: [
                    {
                        question: "What careers do MS Marketing lead to?",
                        answer: (
                            <>
                                Graduates step into roles like brand or product manager, digital-growth strategist, market researcher, and CRM/analytics specialist at tech giants, FMCG leaders, and top agencies—often within 6–12 months of graduation.
                            </>
                        ),
                    },
                    {
                        question: "Is Masters in Marketing worth it?",
                        answer: (
                            <>
                                Yes—one focused year boosts your analytics, brand, and digital skill-set, landing roles that pay 20-30 % more than typical entry positions. The fast ROI, global network, and accelerated career path make it a smart investment for early professionals.
                            </>
                        ),
                    },
                    {
                        question: "Will I get job support after the degree?",
                        answer: (
                            <>
                                Yes, top MS Marketing programs provide dedicated career teams, recruiter treks, and on-campus hiring fairs, and GradBrew’s optional Career Studio add-on keeps guiding you toward internships and full-time roles even after you enrol.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "GradBrew Support",
                items: [
                    {
                        question: "Can GradBrew help with non-standard applications like portfolios or creative writing prompts?",
                        answer: (
                            <>
                                Absolutely. We offer tailored support for creative submissions, project-based evaluations, and even technical/video-based interview prep — all included in your package. <br /> Our mentors review design decks, campaign reels, and storytelling briefs, then coach you on structure, tone, and visual punch so non-standard materials wow the ad-com without losing your voice.
                            </>
                        ),
                    },
                    {
                        question: "What’s different about GradBrew’s approach?",
                        answer: (
                            <>
                                <ul>
                                    <li>No ghostwriting — your story, ethically told</li>
                                    <li>Unlimited edits + dual-consultant feedback</li>
                                    <li>AI-assisted tools to save time</li>
                                    <li>Specialisation-specific guidance from real experts</li>
                                </ul>
                            </>
                        ),
                    },
                ],
            },
        ],
        ctaConfig: {
            title: "Ready to Launch Your Master in Marketing Journey with GradBrew?",
            description: `
                <ul>
                    <li><strong>Early-career game plan</strong> – dual-consultant roadmap turns class projects, campaigns, and internships into a market-ready profile.</li><br/>
                    <li><strong>AI-boosted, human-first</strong> – smart prompts plus alumni insight shape essays and creative briefs—always your voice, never ghostwritten.</li><br/>
                    <li><strong>Creative & analytics readiness</strong> – portfolio polish, digital-metrics storytelling, and school-style interview drills that prove both flair and data chops.</li><br/>
                    <li><strong>Scholarship & waiver edge</strong> – targeted tweaks win tuition discounts, test waivers, and merit aid at marketing-centric schools.</li><br/>
                    <li><strong>Post-admit launch</strong> – visa, housing, and optional Career Studio access to secure brand or agency internships before day one.</li><br/><br/>
                </ul>`,
            buttons: [
                { href: "#pricing-plan", text: "Pricing", className: "button is-large w-button" },
                { href: "#why-us", text: "Why US?", className: "button-outline is-large w-button" }
            ]
        }
    },
    'undergraduate-bachelors-abroad': {
        pricingKey: "BACHELORS",
        pricingTitle: "Tailored made pricing plans for your Bachelor’s degree abroad journey",
        productHomeHeroConfig: {
            title: "Kick-start Your Global Future with a Top Bachelor’s Degree",
            subtitle: `Earn offers from Ivy League, Oxbridge, and leading universities— straight from high school`,
            description: "Studying for a bachelor's degree abroad means applying to top US, UK, and EU universities straight from high school. GradBrew guides students through every stage — grades, activities, tests, and essays — to win offers from the Ivy League, Oxbridge, LSE, and Bocconi, with a <strong>personalised roadmap, ethical storytelling, and expert mentorship</strong>.",

            heroImage: {
                src: "/GradBrew_Undergrad header.png",
                alt: "GradBrew Bachelor’s Degree"
            },
            brandsTitle: "Where Our Mentors Come From & Our Clients Get In",
            ctas: ctas,
            brands: [
                {
                    src: "/Homepage_headerimg ESCP logo.png",
                    alt: "ESCP Business School"
                },
                {
                    src: "/NUS_logo_og.png",
                    alt: "National University of Singapore"
                },
                {
                    src: "/Homepage_headerimg_LSE logo.png",
                    alt: " London School of Economics and Political Science"
                },
                {
                    src: "/Bocconi_University_Logo.png",
                    alt: "Università Bocconi"
                },
                {
                    src: "/Wharton_logo_og.png",
                    alt: "Wharton School of the University of Pennsylvania"
                },
                {
                    src: "/University_of_Michigan_Logo_og.png",
                    alt: "University of Michigan"
                },
                {
                    src: "/ESSEC logo.png",
                    alt: "ESSEC Business School"
                },
                {
                    src: "/Ivey_logo_og.jpg",
                    alt: "Ivey Business School"
                },
                {
                    src: "/HKUST_Business_School_logo.png",
                    alt: "HKUST Business School"
                }
            ]
        },
        industrySolutionsConfig: [
            {
                //iconDark: "https://dummyimage.com/460x460/fef/aba",
                //icon: "https://dummyimage.com/460x460/fef/aba",
                title: "Bachelors degree at a Glance",
                description: (
                    <>
                        <li><strong>Target audience:</strong> High-school seniors and recent school leavers who want a global business foundation straight out of Grade 12.</li><br />
                        <li><strong>Core focus:</strong> Economics, management basics, quantitative analytics, and cross-cultural teamwork—backed by mandatory internships.</li><br />
                        <li><strong>Career outcomes:</strong> First roles in consulting, finance analyst programs, brand marketing, start-up operations, and leadership development tracks.</li><br />
                        <li><strong>Degree format:</strong> A 3- to 4-year bachelor’s that blends case studies, live company projects, and study-abroad semesters for a worldwide outlook.</li><br />
                        <li><strong>Network effect:</strong> Early immersion in a global alumni base and on-campus recruiters—opening career doors before graduation day.</li>

                    </>
                ),
            },
            {
                //iconDark: "https://dummyimage.com/460x460/fef/aba",
                //icon: "https://dummyimage.com/460x460/fef/aba",
                title: "Who Should Apply?",
                description: (
                    <ol style={{ paddingLeft: "0" }}>
                        <li><strong>High-school seniors or gap-year students—</strong> strong grades, leadership roles, or standout projects that show initiative.</li><br />
                        <li><strong>Any curriculum welcome—</strong> IB, A-Levels, AP, CBSE, or national boards; top marks and rigorous courses matter most.</li><br />
                        <li><strong>SAT / ACT flexible—</strong> 1400+ / 32+ strengthens your file, but many top schools are now test-optional.</li><br />
                        <li><strong>English-ready—</strong> TOEFL/IELTS needed only if your schooling wasn’t fully in English.</li><br />
                        <li><strong>Global vision—</strong> a clear “Why international bachelors degree” and career goals in management, entrepreneurship, or analytics.</li><br />
                        <li><strong>Worldwide intakes—</strong> most cohorts start August/September; some offer January or Spring entry options.</li>
                    </ol>
                ),
            },
            {
                title: "Studying in the US vs the UK: Key Differences",
                description: (
                    <ul style={{ paddingLeft: "1.25rem" }}>
                        <li><strong>Degree length:</strong> a US bachelor's typically takes 4 years; UK degrees usually take 3.</li>
                        <li><strong>Flexibility:</strong> the US starts broad (liberal arts) with a later major; the UK is specialised in your subject from year one.</li>
                        <li><strong>Applications:</strong> the US uses the Common App with essays and activities; the UK uses UCAS with a single personal statement.</li>
                        <li><strong>Tests:</strong> SAT/ACT are often optional in the US; the UK weighs predicted grades (A-Levels/IB) and some subject tests.</li>
                        <li><strong>Cost &amp; aid:</strong> US costs vary widely with more scholarship and need-aid options; UK fees are more uniform with fewer aid routes for internationals.</li>
                    </ul>
                ),
            },
        ],
        industryBenefitsConfig: {
            headline: "Why choose GradBrew for your Bachelor’s degree abroad?",
            benefitList: [
                {
                    icon: "/Smart_Profile_Eval.png",
                    title: "Smart Profile Snapshot",
                    description: "Instant, honest read-out of grades, activities, and test scores— so we target the right tier from day one.",
                },
                {
                    icon: "/Data_driven_shortlist.png",
                    title: "School Shortlisting Strategy",
                    description: "Expert guidance to identify suitable courses globally. A balanced list of dream, competitive, and safe schools.",
                },
                {
                    icon: "/Essay_SOP_authentic.png",
                    title: "Essays and SOPs – Real YOU",
                    description: "Authentic and impactful essays. Your voice, our strategy: first draft by you (or AI), then Lead Consultant review + Second Expert feedback.",
                },
                {
                    icon: "/CV_LOR_Support.png",
                    title: "Activity, Portfolio and CV Boost",
                    description: "Global-standard action plan to turn clubs, projects, and passion work into résumé-ready wins that impress ad-coms.",
                },
                {
                    icon: "/Scholarship_review.png",
                    title: "SAT / ACT & English-Test Strategy",
                    description: "Score-raise roadmap or test-optional tactics— whichever gets you the biggest admissions edge.",
                },
                {
                    icon: "/Dual_Consultant.png",
                    title: "Dual Consultant Review",
                    description: "Lead Consultant shapes strategy; second top-school expert gives the pre-submit once-over. Two sets of eyes, zero weak links.",
                },
                {
                    icon: "/School_style_mock.png",
                    title: "Interview & Video Essay Prep",
                    description: "School-style mock interviews and recorded video drills— confidence locked before the real thing.",
                },
                {
                    icon: "/Personalised_planner.png",
                    title: "Parent + Student Dashboard",
                    description: "Stay organized with deadlines, documents, and feedback in one place. Track milestones, uploads, and feedback.",
                },
                {
                    icon: "/Post_admit_guide.png",
                    title: "Post-Admit Guidance/Tips",
                    description: "Tips on visas, housing, and settling in — based on your admitted country.",
                },
            ],
        },
        industryFeaturesTitle: "Your GradBrew Bachelor's Degree Journey — Step by Step",
        industryFeaturesConfig: [
            {
                title: "Profile Kick-off Audit",
                description: (
                    <>
                        High-signal intake form + intro call.<br />Grades, tests, activities, budget all mapped.<br />Walk away with a precise action roadmap. <br /><br /> Sets a data-driven baseline so every later move is targeted— parents see exactly where the gaps and opportunities lie.
                    </>
                ),
                image: {
                    src: "/Gradbrew Undergrad step 1.png",
                    alt: "Profile Kick-off Audit",
                },
            },
            {
                title: "Spike Builder & Test Game Plan",
                description: (
                    <>
                        Identify one “wow” activity and set milestones.<br />Lock SAT/ACT/IELTS dates and a score-boost study plan.<br />Monthly check-ins keep both on track.<br /><br /> Converts scattered hobbies into résumé gold and prevents last-minute test panic— maximising admission and scholarship odds.
                    </>
                ),
                image: {
                    src: "/Gradbrew Undergrad step 2.png",
                    alt: "Spike Builder & Test Plan",
                },
            },
            {
                title: "Smart College Shortlist & Visit Plan",
                description: (
                    <>
                        Data + alumni insight craft your reach, target, safety list.<br />ROI, visa, and career fit baked into every pick.<br />Campus-visit or virtual-tour calendar handed over.<br /><br /> Saves time and money by focusing on best-fit schools; reassures parents that each option aligns with long-term goals and budget.
                    </>
                ),
                image: {
                    src: "/Gradbrew Undergrad step 3.png",
                    alt: "Smart College Shortlist & Visit Plan",
                },
            },
            {
                title: "Essays & Portfolio Crafting",
                description: (
                    <>
                        Guided templates turn projects into standout stories.<br />Common App, UCAS, or video supplements shaped in your voice.<br />First drafts ready weeks before deadlines.<br /><br /> Delivers authentic, polished narratives that stand out in a crowded pool—without ghostwriting or last-minute scrambling.
                    </>
                ),
                image: {
                    src: "/Gradbrew Undergrad step 4.png",
                    alt: "Essays & Portfolio Crafting",
                },
            },
            {
                title: "Dual Review & Submission",
                description: (
                    <>
                        Two top-school mentors polish every essay and LOR.<br />Live dashboard tracks EA/ED and rolling dates.<br />Nothing missed before you click “submit.”<br /><br /> Provides expert quality control and deadline certainty— giving families peace of mind that every box is ticked.
                    </>
                ),
                image: {
                    src: "/Gradbrew Undergrad step 5_main.png",
                    alt: "Dual Review & Submission",
                },
            },
            {
                title: "Interview Mastery & Arrival Prep",
                description: (
                    <>
                        School-specific mock interviews, Kira or video drills, and alumni Q&As ensure you nail the final hurdle.<br />We then hand over a visa, housing, and packing checklist.<br />Walk in confident for the interview, fly out fully prepared.<br /><br /> Acing interviews secures the admit; structured arrival prep removes last-minute chaos— giving both students and parents peace of mind.
                    </>
                ),
                image: {
                    src: "/Gradbrew Undergrad step 6.png",
                    alt: "Interview Mastery & Arrival Prep",
                },
            },
        ],
        faqs: [
            {
                category: "Eligibility and Academic Fit",
                items: [
                    {
                        question: "Who is eligible to apply for a bachelor’s program abroad?",
                        answer: (
                            <>
                                Anyone who will hold a recognized high-school diploma (IB, A-Levels, AP, CBSE, etc.) by the program’s start date can apply. International students must also meet the school’s language and visa requirements.
                            </>
                        ),
                    },
                    {
                        question: "Does my high-school curriculum affect my chances?",
                        answer: (
                            <>
                                Selective universities convert every curriculum to a common scale; rigor and grades matter more than the board itself. Taking higher-level or honors courses signals readiness.
                            </>
                        ),
                    },
                    {
                        question: "Can I switch majors later if I’m unsure today?",
                        answer: (
                            <>
                                Most U.S. and many European schools allow major changes after Year 1. Direct-entry programs (medicine, engineering) are stricter, so verify before applying.
                            </>
                        ),
                    },
                    {
                        question: "Is there an age limit or “gap-year penalty”?",
                        answer: (
                            <>
                                No formal age cap. One structured gap year—work, service, or travel—often enhances your profile, provided you explain the learning value.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Tests and Grade Requirements",
                items: [
                    {
                        question: "Do I need the SAT / ACT?",
                        answer: (
                            <>
                                Roughly half of top U.S. colleges remain test-optional, but submitting strong scores still boosts merit-aid chances and offsets lower GPAs.
                            </>
                        ),
                    },
                    {
                        question: "What counts as a competitive SAT, ACT, or TOEFL/IELTS score?",
                        answer: (
                            <>
                                Aim for SAT 1400+, ACT 32+, TOEFL 105+, or IELTS 8.0+ to be in range for selective schools; adjust upward for Ivies, downward for regionals.
                            </>
                        ),
                    },
                    {
                        question: "Will predicted grades be accepted if final results aren’t out?",
                        answer: (
                            <>
                                Yes. IB and A-Level schools routinely admit on predicted scores, but the offer becomes conditional on your final exam results.
                            </>
                        ),
                    },
                    {
                        question: "Can AP or A-Level credits shorten the degree?",
                        answer: (
                            <>
                                In the U.S. and some Canadian schools, 4–5 on APs or A*/A in A-Levels can waive first-year courses, saving tuition and time.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Application Materials and Deadlines",
                items: [
                    {
                        question: "Which documents are mandatory for the Common App or UCAS?",
                        answer: (
                            <>
                                Transcripts, test scores (if any), personal statement, résumé/activities list, application fee, and school-counselor or teacher recommendations.
                            </>
                        ),
                    },
                    {
                        question: "How many recommendation letters do universities prefer?",
                        answer: (
                            <>
                                Two teachers + one counselor is standard for U.S. schools; UCAS needs one combined reference. Pick teachers who taught you core subjects recently.
                            </>
                        ),
                    },
                    {
                        question: "Is it okay to reuse the same personal statement for multiple schools?",
                        answer: (
                            <>
                                Core story can stay, but always tailor “Why this university/major” paragraphs—ad-coms spot generic essays instantly.
                            </>
                        ),
                    },
                    {
                        question: "When should we start drafting essays?",
                        answer: (
                            <>
                                Begin brainstorming 4–6 months before deadlines; first full draft ideally done by early September for January deadlines.
                            </>
                        ),
                    },
                    {
                        question: "What happens if I miss an Early-Action or Early-Decision deadline?",
                        answer: (
                            <>
                                You default to Regular Decision; admit odds drop slightly and merit-aid pools may shrink, but strong applicants are still competitive.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Cost, Scholarships & Work Options",
                items: [
                    {
                        question: "What is the typical total cost for popular destinations?",
                        answer: (
                            <>
                                Annual cost (tuition + living) ranges: U.S. $45–80 k, UK £25–40 k, Canada CA$35–55 k, EU public options €15–25 k.
                            </>
                        ),
                    },
                    {
                        question: "Are scholarships available to international students?",
                        answer: (
                            <>
                                Yes—merit awards, need-based grants, and country-specific bursaries exist. Apply early and submit any extra scholarship essays.
                            </>
                        ),
                    },
                    {
                        question: "How do I demonstrate proof of funds for the visa?",
                        answer: (
                            <>
                                Bank statements or loan letters covering one year of tuition plus living stipend (exact amount varies by country) are usually required.
                            </>
                        ),
                    },
                    {
                        question: "Can I work part-time during studies?",
                        answer: (
                            <>
                                Most visas permit 15–20 hrs/week in term and full-time in breaks; income helps with living costs but shouldn’t replace planned funding.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "GradBrew Process and Support",
                items: [
                    {
                        question: "How does GradBrew’s undergrad consulting flow work?",
                        answer: (
                            <>
                                Six milestones—profile audit, strategy call, essay blueprint, unlimited revisions, dual-expert review, and interview/arrival prep—tracked in a live dashboard so parents and students always know what’s next.
                            </>
                        ),
                    },
                    {
                        question: "How often will we meet our consultant?",
                        answer: (
                            <>
                                Expect one strategy call per major milestone and quick-turn chat/email feedback in between; urgent questions get a 24-hour response, guaranteed.
                            </>
                        ),
                    },
                    {
                        question: "Are essay edits really unlimited?",
                        answer: (
                            <>
                                Yes. Drafts cycle until you and both your lead consultant and second expert agree they’re admit-ready— no hidden caps, no rush jobs.
                            </>
                        ),
                    },
                    {
                        question: "Who are the consultants reviewing my application?",
                        answer: (
                            <>
                                All lead mentors are alumni of top-tier universities (Ivies, Oxbridge, top EU/Asia schools) with proven advising records; a second alum performs the final audit.
                            </>
                        ),
                    },
                    {
                        question: "Do you write essays for me?",
                        answer: (
                            <>
                                Never—ghostwriting violates our ethical code and most university policies. We coach, critique, and polish; the ideas and words stay yours.
                            </>
                        ),
                    },
                    {
                        question: "What if we’re unhappy with the service?",
                        answer: (
                            <>
                                We offer a satisfaction checkpoint after the first two milestones; if expectations aren’t met, you can opt for a different consultant or process review.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Career Outcomes",
                items: [
                    {
                        question: "What internship opportunities exist for first-year students?",
                        answer: (
                            <>
                                Many universities run first-year leadership or research programs; on-campus roles and virtual micro-internships build experience early.
                            </>
                        ),
                    },
                    {
                        question: "Do employers value a foreign bachelor’s degree over a local one?",
                        answer: (
                            <>
                                For global firms, a reputable international degree plus cross-cultural experience is a strong differentiator—especially in consulting, tech, and finance.
                            </>
                        ),
                    },
                    {
                        question: "How strong is career-services support for international undergrads?",
                        answer: (
                            <>
                                Top schools offer dedicated advisors, résumé workshops, and employer fairs; success depends on proactive use of these resources.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Post-Admit Logistics",
                items: [
                    {
                        question: "What is the typical visa-processing timeline after an offer?",
                        answer: (
                            <>
                                Allow 4–8 weeks once you receive the CAS/I-20 form; peak seasons can extend this, so apply immediately after accepting the offer.
                            </>
                        ),
                    },
                    {
                        question: "How do we secure student housing from abroad?",
                        answer: (
                            <>
                                Most universities guarantee first-year housing if you apply by their deadline; off-campus options can be booked via verified student-letting portals.
                            </>
                        ),
                    },
                    {
                        question: "What medical or health-insurance coverage is required?",
                        answer: (
                            <>
                                U.S. schools mandate campus health plans; UK and some EU countries include basic coverage in visa fees. Always check if supplemental insurance is advised.
                            </>
                        ),
                    },
                    {
                        question: "Do parents need to attend orientation, and can they visit during term?",
                        answer: (
                            <>
                                Parent sessions are optional but helpful; most colleges allow casual visits with prior notice, respecting dorm privacy and academic schedules.
                            </>
                        ),
                    },
                ],
            },
        ],
        ctaConfig: {
            title: "Ready to Kick-Start Your Bachelor’s Journey with GradBrew?",
            description: `
                 <ul>
                    <li><strong>Grade-boost roadmap</strong> – dual-consultant plan turns transcripts, course choices, and activities into a top-tier college profile.</li><br/>
                    <li><strong>AI-powered, student-first</strong> – smart essay templates plus alumni insight shape statements that sound 100 % like you—never ghostwritten.</li><br/>
                    <li><strong>Test & fit readiness</strong> – SAT/ACT strategy, résumé polish, and mock Kira or video interviews that prove both academics and personality.</li><br/>
                    <li><strong>Scholarship & aid edge</strong> – targeted essay tweaks and document sets to win merit awards, need-based grants, and tuition discounts.</li><br/>
                    <li><strong>Post-admit launch</strong> – visa, housing, and optional Career Studio access for securing first-year internships before you hit campus.</li><br/><br/>
                 </ul>`,
            buttons: [
                { href: "#pricing-plan", text: "Pricing", className: "button is-large w-button" },
                { href: "#why-us", text: "Why US?", className: "button-outline is-large w-button" }
            ]
        }
    },
    'specialised-masters': {
        pricingKey: "MASTERS",
        pricingTitle: "Tailored made pricing plans for your Specialised Master’s journey",
        productHomeHeroConfig: {
            title: "Deepen Your Expertise with a Top Specialised Master’s",
            subtitle: "From Data Science to Luxury & Sustainability— stand out in any niche",
            description: "A specialised master's is a 9–18 month degree that builds deep expertise in one field — Data Science, Sustainability/ESG, Asset Management, Luxury, or Strategy — for early-career talent (0–5 years). GradBrew helps you get into programs at schools like LBS, ESCP, HEC, and Chicago Booth, with <strong>tailored strategy, ethics-first guidance, and experienced mentorship</strong>.",

            heroImage: {
                src: "/Gradbrew Specialised Masters header.png",
                alt: "GradBrew Specialised Master’s"
            },
            brandsTitle: "Where Our Mentors Come From & Our Clients Get In",
            ctas: ctas,
            brands: [
                {
                    src: "/Homepage_headerimg_LBS logo.jpg",
                    alt: "London Business School"
                },
                {
                    src: "/Homepage_headerimg ESCP logo.png",
                    alt: "ESCP Business School"
                },
                {
                    src: "/Homepage_headerimg_HEC_Paris logo.png",
                    alt: "HEC Paris"
                },
                {
                    src: "/Homepage_Chicago Booth Logo.jpeg",
                    alt: "The University of Chicago Booth School of Business"
                },
                {
                    src: "/IE _logo_og.png",
                    alt: "IE Business School"
                },
                // {
                //     src: "/WHU_Logo.png",
                //     alt: "WHU – Otto Beisheim School of Management"
                // },
                {
                    src: "/NUS_logo_og.png",
                    alt: "National University of Singapore"
                },
                {
                    src: "/Homepage_UTexas Austin Logo.png",
                    alt: "The University of Texas at Austin"
                },
                {
                    src: "/USC_Marshall_logo.png",
                    alt: "USC Marshall School of Business"
                }
            ]
        },
        industrySolutionsConfig: [
            {
                //iconDark: "https://dummyimage.com/460x460/fef/aba",
                //icon: "https://dummyimage.com/460x460/fef/aba",
                title: "Specialised Masters at a Glance",
                description: (
                    <>
                        <li><strong>Target audience:</strong> Final-year students and early professionals (0–5 years’ experience) seeking deep, domain-specific expertise.</li><br />
                        <li><strong>Core focus:</strong> Intensive training in a single track— Data Science, Sustainability, Asset Management, Luxury, Strategy, or similar—blending theory with live industry projects.</li><br />
                        <li><strong>Career outcomes:</strong> Launch roles such as ESG analyst, brand manager, quant researcher, supply-chain strategist, or data scientist at global firms and specialized boutiques.</li><br />
                        <li><strong>Degree format:</strong> A 9 to 18-month program featuring case labs, corporate capstones, and optional certifications (CFA, Python, ESG reporting, etc.).</li><br />
                        <li><strong>Network effect:</strong> Access to niche-industry mentors and recruiter pipelines that fast-track you into hard-to-enter sectors worldwide.</li>

                    </>
                ),
            },
            {
                //iconDark: "https://dummyimage.com/460x460/fef/aba",
                //icon: "https://dummyimage.com/460x460/fef/aba",
                title: "Who Should Apply?",
                description: (
                    <ol style={{ paddingLeft: "0" }}>
                        <li><strong>0–5 years’ experience—</strong> internships or early roles that show passion for your chosen niche—data, ESG, luxury, strategy, etc.</li><br />
                        <li><strong>Any bachelor’s with solid GPA—</strong> STEM or business degrees add an edge for quant-heavy tracks, but strong coursework trumps major.</li><br />
                        <li><strong>GMAT/GRE flexible—</strong> 615+/324+ strengthens U.S. applications, yet many EU programs waive scores for high GPAs or relevant portfolios.</li><br />
                        <li><strong>Proof of domain focus—</strong> certifications (Python, CFA Level 1, ESG), case comps, or capstone projects validate your specialised interest.</li><br />
                        <li><strong>English-ready—</strong> TOEFL/IELTS required only if your previous studies weren’t in English.</li><br />
                        <li><strong>Global intakes—</strong> majority start each September; select schools open January or April cohorts for added flexibility.</li>
                    </ol>
                ),
            },
            {
                title: "Specialised Master's vs a General Degree: When to Go Niche",
                description: (
                    <ul style={{ paddingLeft: "1.25rem" }}>
                        <li><strong>Focus:</strong> a specialised master's goes deep in one field (Data Science, ESG, Luxury); an MBA or MiM is broad general management.</li>
                        <li><strong>Best for:</strong> choose a specialised master's when you already know your domain; choose an MBA or MiM for flexibility across functions.</li>
                        <li><strong>Experience:</strong> specialised programs suit 0–5 years; an MBA suits 3–8+ years.</li>
                        <li><strong>Length:</strong> a specialised master's runs 9–18 months.</li>
                        <li><strong>Outcomes:</strong> targeted roles (ESG analyst, data scientist, quant) versus general leadership tracks.</li>
                    </ul>
                ),
            },
        ],
        industryBenefitsConfig: {
            headline: "Why choose GradBrew for your Specialised Masters journey?",
            benefitList: [
                {
                    icon: "/Smart_Profile_Eval.png",
                    title: "Smart Profile Evaluation",
                    description: "Clear, honest, and personalised scorecard of your strengths, gaps, and admit odds— so every next step is targeted.",
                },
                {
                    icon: "/Data_driven_shortlist.png",
                    title: "Data-Driven Shortlist",
                    description: "Dream, target, and safety schools selected by alumni + analytics— no random lists, just ROI-fit options worldwide.",
                },
                {
                    icon: "/Essay_SOP_authentic.png",
                    title: "Essays and SOPs — Real YOU",
                    description: "You draft (or AI-draft), we sharpen. Passes by two expert consultants ensure voice, impact, and ethical polish.",
                },
                {
                    icon: "/CV_LOR_Support.png",
                    title: "CV and LOR support",
                    description: "Global Specialised Masters-standard résumé makeover and step-by-step guidance for recommenders to hit leadership keywords.",
                },
                {
                    icon: "/School_style_mock.png",
                    title: "School-Style Mock Interviews",
                    description: "Personal, video, and group case drills that mirror each program’s format—real-time feedback, real confidence.",
                },
                {
                    icon: "/Dual_Consultant.png",
                    title: "Dual Consultant Review",
                    description: "Lead Consultant shapes strategy; second top-school expert gives the pre-submit once-over. Two sets of eyes, zero weak links.",
                },
                {
                    icon: "/Scholarship_review.png",
                    title: "Scholarship + Extra Doc Review",
                    description: "We fine-tune optional essays, scholarship statements, and any addendum— so every supplemental page earns you money or an edge.",
                },
                {
                    icon: "/Personalised_planner.png",
                    title: "Personalised Planner + Dashboard",
                    description: "Deadlines, drafts, feedback— all tracked in one sleek hub. See exactly what’s due and what’s approved, in real time.",
                },
                {
                    icon: "/Post_admit_guide.png",
                    title: "Post-Admit Guidance",
                    description: "Tips on visas, housing, banking, arrival hacks and settling in— based on your admitted country.",
                },
            ],
        },
        industryFeaturesTitle: "Your GradBrew Specialised Masters Journey — Step by Step",
        industryFeaturesConfig: [
            {
                title: "Kick-off: Complete Your Info Sheet",
                description: (
                    <>
                        A fast,high-signal form that captures your academics, experience, and career goals— fueling every tailored move we make next.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Kickoff infosheet.png",
                    alt: "Complete Your Info Sheet",
                },
            },
            {
                title: "Brainstorming: Strategy Call",
                description: (
                    <>
                        A focused 1-to-1 session with your Lead Consultant to lock school targets, carve your story arc, and pinpoint what makes you stand out.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_brainstorming strategy.png",
                    alt: "Brainstorming Call",
                },
            },
            {
                title: "First Drafts: Using Guidance and Smart Tools",
                description: (
                    <>
                        Spin up your first CV, essays, and recommender briefs with smart tools and templates, quick-hit video guides, and tips from your Lead Consultant— all while keeping the voice unmistakably yours.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_first draft.png",
                    alt: "First Drafts Using Smart Tools",
                },
            },
            {
                title: "Consultant Calls and Unlimited Draft Revisions",
                description: (
                    <>
                        Your Lead Consultant deep-dives into your drafts and suggests structured edits. Team works with you to sharpen structure, language, and impact— until every line earns its spot and still sounds unmistakably you.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Con revision.png",
                    alt: "Consultant Discussion & Revisions",
                },
            },
            {
                title: "Final Review by Second Expert Consultant",
                description: (
                    <>
                        Once near-final, a second expert (also a top-school alum) reviews your entire essays/SOP with fresh eyes for final polishing and strategy alignment. Back-to-front audit— spotting gaps, sharpening strategy, and adding the final polish before you hit “submit”.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_Dual expert review.png",
                    alt: "Dual Expert Review",
                },
            },
            {
                title: "Submit Strong and Nail the Interview",
                description: (
                    <>
                        Application locked. Now we drill for every behavioral and technical question with school-style mock sessions— so you walk in confident and walk out admitted. <br /> Need post-admit help? We’re still on call for visas, housing, and day-one prep.
                    </>
                ),
                image: {
                    src: "/GradBrew consulting step_nail interview.png",
                    alt: "Submit Strong and Nail the Interview",
                },
            },
        ],
        faqs: [
            {
                category: "Eligibility and Admissions",
                items: [
                    {
                        question: "Who can apply for a Specialised Master’s?",
                        answer: (
                            <>
                                These programs are designed for recent graduates or professionals (0–5 years of work experience) from any academic background. Some programs prefer relevant exposure (e.g., CS for Data Science), but many welcome career switchers.
                            </>
                        ),
                    },
                    {
                        question: "Do I need work experience?",
                        answer: (
                            <>
                                Most programs are open to applicants without full-time work experience. However, internships, projects, or domain exposure can strengthen your profile — especially for competitive programs.
                            </>
                        ),
                    },
                    {
                        question: "What’s the difference between a Specialised Master’s and an MBA or MiM?",
                        answer: (
                            <>
                                <strong>Specialised Masters</strong> focus deeply on one function or domain (e.g., Analytics, Marketing). <br />
                                <strong>MiM</strong> is a general management degree for recent grads. <br />
                                <strong>MBA</strong> is for professionals with 3+ years of experience looking for leadership/strategic roles. <br />

                            </>
                        ),
                    },
                ],
            },
            {
                category: "Application and Documents",
                items: [
                    {
                        question: "Do I need GMAT or GRE for Specialised Masters?",
                        answer: (
                            <>
                                Some programs require it — especially in the US and for highly competitive tracks. Many European and Canadian programs are test-optional or accept waivers.<br /> We help you decide whether to apply with or without scores.
                            </>
                        ),
                    },
                    {
                        question: "What documents do I need to apply?",
                        answer: (
                            <>
                                Your application usually includes:
                                <ul>
                                    <li>CV/resume</li>
                                    <li>Test scores (GMAT/GRE, TOEFL/IELTS if needed)</li>
                                    <li>Essays/SOPs</li>
                                    <li>Letters of recommendation (LORs)</li>
                                    <li>Academic transcripts</li>
                                    <li>Application form + fee</li>
                                    <li>Additional school-specific requirements</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "Can I apply to multiple programs or fields at once?",
                        answer: (
                            <>
                                Yes. We help you manage multiple applications — even across domains (e.g., Data Science and Sustainability) — by tailoring each SOP, CV, and recommendation strategy.
                            </>
                        ),
                    },
                    {
                        question: "What do top schools look for in a resume?",
                        answer: (
                            <>
                                Impact, leadership, and progression matter more than job titles. We help reframe your experience into a B-school-optimized format.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "Program Outcomes & Fit",
                items: [
                    {
                        question: "What careers do Specialised Masters lead to?",
                        answer: (
                            <>
                                Graduates land in roles tightly aligned with their track— ESG analysts and sustainability consultants, luxury brand or product managers, data scientists and business-analytics leads, asset-management or quant-research associates, and corporate-strategy analysts. <br />The specialised skill-set fast-tracks entry into niche teams at global firms, boutiques, and high-growth startups.

                            </>
                        ),
                    },
                    {
                        question: "Are Specialised Masters worth it?",
                        answer: (
                            <>
                                Yes — if you want to build targeted expertise, shorten your learning curve, and fast-track into an industry. They’re especially valuable if you want domain skills without committing to a full MBA.

                            </>
                        ),
                    },
                    {
                        question: "Will I get job support after the degree?",
                        answer: (
                            <>
                                Top schools offer career services, but the outcomes depend on your program choice, location, language, and job readiness. We also offer pre-departure planning to help you start strong.
                            </>
                        ),
                    },
                ],
            },
            {
                category: "GradBrew Support",
                items: [
                    {
                        question: "Can GradBrew help with non-standard applications like portfolios or creative writing prompts?",
                        answer: (
                            <>
                                Absolutely. We offer tailored support for creative submissions, project-based evaluations, and even technical/video-based interview prep — all included in your package.
                            </>
                        ),
                    },
                    {
                        question: "What’s different about GradBrew’s approach?",
                        answer: (
                            <>
                                <ul>
                                    <li>Ethical consulting — no ghostwriting</li>
                                    <li>Two expert consultants per school</li>
                                    <li>AI-assisted planning tools and feedback</li>
                                    <li>Domain depth: mentors come from the very tracks you’re targeting—ESG, luxury, data, or finance—so guidance is truly specialised.</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        question: "Can GradBrew help with scholarship essays?",
                        answer: (
                            <>
                                Yes. Scholarship support is included in all packages — we help connect your goals and background to the school’s impact themes.
                            </>
                        ),
                    },
                ],
            },
        ],
        ctaConfig: {
            title: "Ready to Deepen Your Expertise with GradBrew’s Specialised Masters Support?",
            description: `
               <ul>
                    <li><strong>Niche-specific roadmap</strong> – dual-consultant strategy aligns your projects and passion with the exact requirements of Data, ESG, Luxury, or any specialised track.</li><br/>
                    <li><strong>AI-powered, mentor-refined</strong> – smart templates plus alumni insight craft essays in your own voice—never ghostwritten, always track-focused.</li><br/>
                    <li><strong>Portfolio & fit readiness</strong> – coding demos, ESG case decks, or luxury brand projects polished alongside GMAT/GRE guidance and interview drills.</li><br/>
                    <li><strong>Scholarship & waiver edge</strong> – precision tweaks that open up merit aid, tuition discounts, and test exemptions at niche programs.</li><br/>
                    <li><strong>Post-admit launch</strong> – visa, housing, and optional Career Studio access to secure specialised internships before you land on campus.</li><br/><br/>
              </ul>`,
            buttons: [
                { href: "#pricing-plan", text: "Pricing", className: "button is-large w-button" },
                { href: "#why-us", text: "Why US?", className: "button-outline is-large w-button" }
            ]
        }
    },
}
